var kr = Object.create;
var _e = Object.defineProperty;
var qr = Object.getOwnPropertyDescriptor;
var rt = (e, t) => (t = Symbol[e]) ? t : /* @__PURE__ */ Symbol.for("Symbol." + e), ne = (e) => {
  throw TypeError(e);
};
var nt = (e, t, r) => t in e ? _e(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Xe = (e, t) => _e(e, "name", { value: t, configurable: !0 });
var me = (e) => [, , , kr(e?.[rt("metadata")] ?? null)], it = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], re = (e) => e !== void 0 && typeof e != "function" ? ne("Function expected") : e, Gr = (e, t, r, n, i) => ({ kind: it[e], name: t, metadata: n, addInitializer: (o) => r._ ? ne("Already initialized") : i.push(re(o || null)) }), ie = (e, t) => nt(t, rt("metadata"), e[3]), he = (e, t, r, n) => {
  for (var i = 0, o = e[t >> 1], s = o && o.length; i < s; i++) t & 1 ? o[i].call(r) : n = o[i].call(r, n);
  return n;
}, D = (e, t, r, n, i, o) => {
  var s, a, c, l, d, p = t & 7, C = !!(t & 8), P = !!(t & 16), b = p > 3 ? e.length + 1 : p ? C ? 1 : 2 : 0, I = it[p + 5], q = p > 3 && (e[b - 1] = []), m = e[b] || (e[b] = []), y = p && (!P && !C && (i = i.prototype), p < 5 && (p > 3 || !P) && qr(p < 4 ? i : { get [r]() {
    return et(this, o);
  }, set [r](E) {
    return tt(this, o, E);
  } }, r));
  p ? P && p < 4 && Xe(o, (p > 2 ? "set " : p > 1 ? "get " : "") + r) : Xe(i, r);
  for (var S = n.length - 1; S >= 0; S--)
    l = Gr(p, r, c = {}, e[3], m), p && (l.static = C, l.private = P, d = l.access = { has: P ? (E) => $r(i, E) : (E) => r in E }, p ^ 3 && (d.get = P ? (E) => (p ^ 1 ? et : Vr)(E, i, p ^ 4 ? o : y.get) : (E) => E[r]), p > 2 && (d.set = P ? (E, M) => tt(E, i, M, p ^ 4 ? o : y.set) : (E, M) => E[r] = M)), a = (0, n[S])(p ? p < 4 ? P ? o : y[I] : p > 4 ? void 0 : { get: y.get, set: y.set } : i, l), c._ = 1, p ^ 4 || a === void 0 ? re(a) && (p > 4 ? q.unshift(a) : p ? P ? o = a : y[I] = a : i = a) : typeof a != "object" || a === null ? ne("Object expected") : (re(s = a.get) && (y.get = s), re(s = a.set) && (y.set = s), re(s = a.init) && q.unshift(s));
  return p || ie(e, i), y && _e(i, r, y), P ? p ^ 4 ? o : y : i;
}, z = (e, t, r) => nt(e, typeof t != "symbol" ? t + "" : t, r), De = (e, t, r) => t.has(e) || ne("Cannot " + r), $r = (e, t) => Object(t) !== t ? ne('Cannot use the "in" operator on this value') : e.has(t), et = (e, t, r) => (De(e, t, "read from private field"), r ? r.call(e) : t.get(e));
var tt = (e, t, r, n) => (De(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r), Vr = (e, t, r) => (De(e, t, "access private method"), r);
import { ApplyModes as Wr, ApplyResponseCode as u, ApplicantType as Q, ProviderApplyOperation as Ce, DeviceType as ce, LogLevel as oe, useOmniApplyApiClient as g, BadRequestException as jt, OmniApplyApiClientKey as jr, OmniApplyClientPlugin as Hr, getOmniApplyClient as zr, ApiException as Yr, SendVerificationCodeStatus as Ht, VerifyCodeStatus as zt } from "@versatile-credit-apply/omni-apply-client";
import { computed as h, nextTick as x, toValue as f, onMounted as Yt, watch as G, unref as Qr, inject as be, createApp as Jr, onUnmounted as Qt, watchEffect as Zr, ref as F, toRaw as ot } from "vue";
import { get as Jt, find as Xr, clamp as en, flatten as tn, values as st, map as at, set as ct, keys as Ue, sortBy as lt, keyBy as rn, last as Zt } from "lodash-es";
import { daysBetween as nn, formatDate as on, dayjs as dt, globalSuspense as sn, SynchronizingRouteGuard as Xt, HistoryRouteGuard as er, useApplicationLocales as an, useApplicationI18n as cn } from "@ui-kit/sdk";
import { daysBetween as el, toLocalDate as tl, useApplicationI18n as rl } from "@ui-kit/sdk";
import { useMemoize as tr, useAsyncState as ue, useTimeoutFn as ln, watchDebounced as dn, useDebounceFn as un, useScriptTag as pn } from "@vueuse/core";
import { defineStore as k, getActivePinia as Se, createPinia as fn } from "pinia";
import { createPersistedState as mn } from "pinia-plugin-persistedstate";
import { compile as hn } from "path-to-regexp";
import { EventBus as yn } from "@primeuix/utils/eventbus";
import { getRumSession as X, reportBusinessEvent as Z, userAction as L } from "@ui-kit/instrumentation";
import ut from "js-cookie";
import { useRouter as We, createRouter as rr, routerKey as vn, createRouterMatcher as gn, useRoute as nr, createWebHashHistory as ir } from "vue-router";
import { useI18n as je } from "vue-i18n";
import Pn from "print-js";
Object.defineProperty(Array.prototype, "first", {
  enumerable: !1,
  configurable: !0,
  value: function() {
    if (this.length === 0)
      throw new Error("Array[] is empty");
    return this[0];
  }
});
Object.defineProperty(Array.prototype, "firstOrUndefined", {
  configurable: !0,
  enumerable: !1,
  value: function() {
    return this.length ? this[0] : void 0;
  }
});
Object.defineProperty(String.prototype, "includesIgnoreCase", {
  enumerable: !1,
  configurable: !0,
  value: function(e) {
    const t = this.length, r = e.length;
    if (r > t)
      return !1;
    for (let n = 0; n <= t - r; n++) {
      let i = 0;
      for (; i < r && // @ts-expect-error will be defined
      this[n + i].toLowerCase() === e[i].toLowerCase(); )
        i++;
      if (i === r)
        return !0;
    }
    return !1;
  }
});
Object.defineProperty(String.prototype, "startsWithIgnoreCase", {
  enumerable: !1,
  configurable: !0,
  value: function(e) {
    const t = this.length, r = e.length;
    if (r > t)
      return !1;
    for (let n = 0; n < r; n++)
      if (this[n].toLowerCase() !== e[n].toLowerCase())
        return !1;
    return !0;
  }
});
Object.defineProperty(String.prototype, "endsWithIgnoreCase", {
  enumerable: !1,
  configurable: !0,
  value: function(e) {
    const t = this.length, r = e.length;
    if (r > t)
      return !1;
    for (let n = 0; n < r; n++)
      if (
        // @ts-expect-error will be defined
        this[t - r + n].toLowerCase() !== e[n].toLowerCase()
      )
        return !1;
    return !0;
  }
});
function qs(e, t, r = "/apply") {
  const n = Object.values(Wr).join("|"), i = new RegExp(`${r}/(${n})/`);
  return e.replace(i, `${r}/${t}/`);
}
const pt = (e, t, r) => !t || t === "$it" ? r : Jt(e, t), wn = (e) => {
  if (e)
    return Array.isArray(e) ? e.length ? e[0] : void 0 : e.value?.length ? e.value[0] : void 0;
}, Gs = (e, t) => {
  const r = e.find(t);
  if (r) {
    const n = e.indexOf(r);
    n > -1 && e.splice(n, 1);
  }
}, An = (e, t) => {
  if (e.length < 2)
    return e;
  const r = or(t);
  return e.slice().sort(r);
}, or = (e) => {
  if (typeof e == "string")
    return bn(e);
  if (typeof e == "function")
    return Rn(e);
  if (Array.isArray(e))
    return Sn(e);
  throw new Error(`Invalid sort rule: ${e}`);
}, Sn = (e) => {
  const t = e.map(or);
  return (r, n) => {
    for (const i of t) {
      const o = i(r, n);
      if (o !== 0)
        return o;
    }
    return 0;
  };
}, Rn = (e) => (t, r) => {
  const n = e(t), i = e(r);
  return n === i ? 0 : n < i ? -1 : 1;
}, bn = (e) => {
  let t = "", r = e, n = 1;
  r.startsWith("-") && (n = -1, r = r.slice(1));
  const i = r.indexOf(":");
  i > -1 && (t = r.slice(i + 1), r = r.slice(0, i));
  const o = t.includes("i");
  return (s, a) => {
    let c = pt(s, r), l = pt(a, r);
    return o && (c = typeof c == "string" ? c.toLowerCase() : c, l = typeof l == "string" ? l.toLowerCase() : l), c === l ? 0 : c < l ? -1 * n : n;
  };
}, $s = (e, t) => {
  let r = null;
  return () => {
    r && window.clearTimeout(r), r = window.setTimeout(e, t);
  };
}, Vs = (e, t) => {
  let r = null;
  return async () => (r && window.clearTimeout(r), new Promise((n, i) => {
    r = window.setTimeout(async () => {
      try {
        const o = await e();
        n(o);
      } catch (o) {
        i(o);
      }
    }, t);
  }));
}, se = (e, t) => new Promise((r) => {
  setTimeout(() => {
    r(t());
  }, e);
}), Ws = (e) => new Promise((t) => {
  setTimeout(() => {
    t();
  }, e);
}), js = (e) => (t) => {
  for (const r of e)
    if (!r(t))
      return !1;
  return !0;
}, Hs = (e) => e.responseCode === u.APPROVED, En = (e) => e.responseCode === u.PENDING, ft = (e) => e.responseCode === u.PREQUALIFIED || e.responseCode === u.PREAPPROVED, zs = (e) => (t) => t.providerKey === e.providerKey, Cn = (e) => (t) => t.providerKey === e, sr = (e) => (t) => t.applicantType === e, Ys = (e) => e.type ? sr(e.type) : () => !1, Qs = sr(
  Q.JOINT
), ar = (e) => (t) => t.type === e, Js = ar(Q.PRIMARY), Zs = ar(Q.JOINT), Xs = (e, t) => (r) => e(r) && t(r), Ke = (e, t) => "value" in e ? e.value.find(t) : e.find(t), ea = (e, t) => h(() => Ke(e, t)), Be = (e, t) => "value" in e ? e.value.filter(t) : e.filter(t), ta = (e, t) => h(() => Be(e, t));
class ke {
  _value;
  _providerKey;
  _modifiers;
  constructor(t) {
    this._value = t;
    const r = t.indexOf(":");
    r > 0 ? (this._providerKey = t.substring(0, r), this._modifiers = new Map(
      t.substring(r + 1).split(":").map((n) => {
        const i = n.toLowerCase();
        return i.includes("=") ? i.split("=") : [i, "true"];
      })
    )) : (this._providerKey = t, this._modifiers = /* @__PURE__ */ new Map());
  }
  get providerKeyFqn() {
    return this._value;
  }
  get providerKey() {
    return this._providerKey;
  }
  get modifiers() {
    return this._modifiers;
  }
  get isJoint() {
    return this._modifiers.get("joint") === "true";
  }
  toString() {
    return this._value;
  }
}
const In = {
  asyncOfferAcceptance: !1,
  asyncApplicationSubmission: !1,
  asyncPrequalifySubmission: !1,
  submitAfterPrequalify: !1,
  asyncPrequalifySubmissionRequiresRefresh: !1,
  refreshApplicationAfterPrequalified: !1,
  displayPaymentCalculations: () => !0,
  displayPaymentPlanDetails: () => !0,
  excludePurchaseAmountFromMaxFinancing: !1,
  displayDeclineMessageWithOffer: !0,
  fetchPaymentPlansOnApproval: !0,
  fetchPaymentPlansOnPreauthApproval: !1,
  requiresAccountCreation: !1,
  requiresCodeVerification: !1,
  requiresEmailOnSmsVerification: !1,
  requiresSelectPlan: !0,
  supportsDownPaymentAdjustment: !0,
  supportsPurchaseAmountAdjustment: !1,
  supportsFullApply: !0,
  switchToFullApplyAfterPrequal: !1,
  termsType: "image",
  hydrationPostProcessing: {
    loadPaymentPlans: !0,
    loadPurchaseDetails: !1
  },
  accountFoundEndsApplication: !1
}, Mn = A(
  "acima",
  "acima_standard",
  {
    switchToFullApplyAfterPrequal: !0
  }
), On = A("ads", "ads_standard", {
  accountFoundEndsApplication: !0,
  requiresSelectPlan: !1
}), Tn = A("aff", "aff_standard", {
  excludePurchaseAmountFromMaxFinancing: !0
}), _n = A("aqua", "aqua_standard", {
  asyncPrequalifySubmission: !0,
  termsType: "none"
}), Dn = A(
  "bread",
  "bread_standard",
  {
    hydrationPostProcessing: {
      loadPaymentPlans: !1,
      loadPurchaseDetails: !0
    },
    requiresCodeVerification: !0,
    requiresEmailOnSmsVerification: !0
  }
), mt = A(
  "versatile",
  "internal"
), Fn = A(
  "dividend",
  "dividend_standard"
), Nn = A(
  "fortiva",
  "fortiva_standard",
  {
    excludePurchaseAmountFromMaxFinancing: !0
  }
), xn = A(
  "foundation",
  "foundation_standard",
  {
    asyncApplicationSubmission: !0,
    asyncPrequalifySubmission: !0,
    asyncPrequalifySubmissionRequiresRefresh: !0,
    refreshApplicationAfterPrequalified: !0,
    termsType: "none"
  }
), Ln = A("gafco", "gaf_standard"), Un = A(
  "genesis",
  "genesis_standard",
  {
    excludePurchaseAmountFromMaxFinancing: !0,
    termsType: "none"
  }
), Kn = A(
  "greensky",
  "greensky_standard",
  {
    asyncOfferAcceptance: !0,
    displayDeclineMessageWithOffer: !1,
    requiresAccountCreation: !0,
    supportsPurchaseAmountAdjustment: !0,
    supportsFullApply: !1,
    termsType: "html"
  }
), Bn = A("hfd", "hfd_standard", {
  excludePurchaseAmountFromMaxFinancing: !0,
  fetchPaymentPlansOnError: !0,
  fetchPaymentPlansOnPreauthApproval: !0,
  fetchPaymentPlansOnApproval: !1
}), kn = A(
  "kafene",
  "kafene_standard"
), qn = A(
  "koalafi",
  "koalafi_standard",
  {
    fetchPaymentPlansOnApproval: !1
  }
), Gn = A(
  "lendingclub",
  "lendingclub_standard",
  {
    excludePurchaseAmountFromMaxFinancing: !0
  }
), $n = A(
  "lendingpoint",
  "lendingpoint_standard"
), Vn = A(
  "momnt",
  "momnt_standard",
  {
    termsType: "none",
    supportsDownPaymentAdjustment: !1
  }
), Wn = A(
  "powerpay",
  "powerpay_standard",
  {
    termsType: "none"
  }
), jn = A("proceed", "proceed_standard", {
  excludePurchaseAmountFromMaxFinancing: !0,
  fetchPaymentPlansOnApproval: !1,
  fetchPaymentPlansOnPreauthApproval: !0
}), Hn = A(
  "progressive",
  "progressive_standard",
  {
    fetchPaymentPlansOnApproval: !1
  }
), zn = A(
  "service_finance",
  "service_finance_standard",
  {
    displayPaymentCalculations: (e) => e.tags["risk-based"] !== "true",
    displayPaymentPlanDetails: (e) => e.tags["risk-based"] !== "true",
    supportsDownPaymentAdjustment: !1
  }
), Yn = A(
  "sonrava",
  "sonrava_standard"
), Qn = A("snap", "snap_standard", {
  fetchPaymentPlansOnApproval: !1
}), Jn = A(
  "sunlight",
  "sunlight_standard",
  {
    termsType: "none",
    submitAfterPrequalify: !0
  }
), Zn = A(
  "synchrony",
  "synchrony_standard",
  {
    excludePurchaseAmountFromMaxFinancing: !0
  }
), Xn = A(
  "tdbank",
  "tdbank_standard"
), ei = A("tguc", "tguc_standard", {
  termsType: "none"
}), ti = A(
  "upgrade",
  "upgrade_standard",
  {
    termsType: "none",
    supportsDownPaymentAdjustment: !1
  }
), ri = A(
  "watercress",
  "watercress_standard",
  {
    asyncPrequalifySubmission: !0,
    termsType: "none",
    supportsDownPaymentAdjustment: !1
  }
), ni = A(
  "wells_fargo",
  "wells_fargo_standard",
  {
    termsType: "none"
  }
), ii = [
  Mn,
  On,
  Tn,
  _n,
  Dn,
  Fn,
  Nn,
  xn,
  Ln,
  Un,
  Kn,
  Bn,
  kn,
  qn,
  Gn,
  $n,
  Vn,
  Wn,
  jn,
  Hn,
  zn,
  Yn,
  Qn,
  Jn,
  Zn,
  Xn,
  ei,
  ti,
  ri,
  ni
], N = (e) => e.indexOf(":") > 0 ? e.substring(0, e.indexOf(":")) : e, ra = (e) => e ? N(e) : null, U = (e) => {
  if (!e)
    return mt;
  let t = null;
  const r = (n) => n.providerId === e ? !0 : (t ??= N(e), n.providerKey === t);
  return ii.find(r) || mt;
};
function A(e, t, r) {
  return {
    ...In,
    ...r,
    providerId: e,
    providerKey: t
  };
}
class oi {
  _key;
  _applicant;
  _offers;
  _acceptedOffer;
  constructor(t, r, n) {
    this._key = yr(), this._applicant = t, this._offers = r, this._acceptedOffer = n;
  }
  get key() {
    return this._key;
  }
  get applicant() {
    return this._applicant;
  }
  get firstName() {
    return this._applicant.firstName || "";
  }
  get fullName() {
    return `${this.applicant.firstName} ${this.applicant.lastName}`.trim();
  }
  get offers() {
    return this._offers;
  }
  get prequalifiedOffers() {
    return Be(this._offers, ft);
  }
  get pendingOffers() {
    return Be(this._offers, En);
  }
  get acceptedOffer() {
    return this._acceptedOffer;
  }
  get isPrequalified() {
    return !this.hasAcceptedOffer && !!Ke(this._offers, ft);
  }
  get hasAcceptedOffer() {
    return !!this._acceptedOffer;
  }
  get preauthResponseForAcceptedOffer() {
    if (this._acceptedOffer)
      return Ke(
        this._offers,
        Cn(this._acceptedOffer.providerKey)
      );
  }
  get providerModuleForAcceptedOffer() {
    return U(this._acceptedOffer?.providerKey);
  }
}
class na {
  _offers;
  _providerConfigs;
  constructor(t, r) {
    this._offers = t, this._providerConfigs = r;
  }
  get offers() {
    return this._offers;
  }
  get acceptedOffers() {
    return [...this._offers.values()].filter((t) => t.hasAcceptedOffer);
  }
  get prequalifiedOffers() {
    const t = this.acceptedOffers.length > 0, r = [...this._offers.values()].filter(
      (n) => n.isPrequalified
    );
    return t ? r.map((n) => {
      const i = n.prequalifiedOffers.filter(
        (o) => this.supportsMultipleApplicants(o.providerKey)
      );
      return new oi(
        n.applicant,
        i,
        n.acceptedOffer
      );
    }) : r;
  }
  get singleOffer() {
    const t = this.prequalifiedOffers;
    return wn(t);
  }
  get allPrequalifiedOffers() {
    return this.prequalifiedOffers.flatMap((t) => t.prequalifiedOffers);
  }
  get allPendingOffers() {
    return [...this._offers.values()].flatMap((t) => t.pendingOffers);
  }
  get jointApplicant() {
    return this._offers.get(Q.JOINT);
  }
  get hasJointApplicant() {
    return this._offers.has(Q.JOINT);
  }
  get hasAdditionalOffersToAccept() {
    const t = this.acceptedOffers;
    return !t.length || !(t.map(
      (n) => this.supportsMultipleApplicants(n.acceptedOffer?.providerKey)
    ).filter((n) => !n).length === 0) ? !1 : this.prequalifiedOffers.flatMap((n) => n.prequalifiedOffers).some((n) => this.supportsMultipleApplicants(n.providerKey));
  }
  supportsMultipleApplicants(t) {
    return t ? Xr(this._providerConfigs, {
      providerKey: t
    })?.supportsMultipleApplicantOfferAcceptance ?? !1 : !1;
  }
}
class ye {
  _start = null;
  _resume = null;
  _responses = [];
  _firstResponse = null;
  _lastResponse = null;
  _approvedResponse = null;
  _provider;
  _mode;
  _initialProvider;
  _initialMode;
  _autoSubmit = !1;
  _approvalCodes = [
    u.APPROVED,
    u.PREQUALIFIED,
    u.PREQUALIFIED
  ];
  constructor(t, r) {
    this._provider = t, this._mode = r, this._initialProvider = t, this._initialMode = r;
  }
  async execute(t) {
    return this.appendResponse(await t(this.provider)), this;
  }
  appendResponse(t) {
    const r = {
      ...t,
      applyMode: t.provider?.operation === Ce.ACCEPT_OFFER ? "full" : this.mode
    };
    return this._responses.push(r), this._firstResponse ??= r, this.isApproved(r) && !this._approvedResponse && (this._approvedResponse = r), this._lastResponse = r, r;
  }
  get firstResponse() {
    if (!this._firstResponse)
      throw new Error("First Response not set!");
    return this._firstResponse;
  }
  get lastResponse() {
    if (!this._lastResponse)
      throw new Error("Last Response not set!");
    return this._lastResponse;
  }
  get approvedResponse() {
    return this._approvedResponse;
  }
  get autoSubmit() {
    return this._autoSubmit;
  }
  set autoSubmit(t) {
    this._autoSubmit = t;
  }
  get start() {
    return this._start;
  }
  set start(t) {
    this._start = t;
  }
  get resume() {
    return this._resume;
  }
  set resume(t) {
    this._resume = t;
  }
  get provider() {
    return this._provider;
  }
  set provider(t) {
    this._provider = t;
  }
  get mode() {
    return this._mode;
  }
  set mode(t) {
    this._mode = t;
  }
  get responses() {
    return [...this._responses];
  }
  isApproved(t) {
    return !!t.provider && this._approvalCodes.includes(t.provider?.responseCode);
  }
  hasLastResponse() {
    return this._lastResponse != null;
  }
}
class ve {
  _context;
  _approvalCodes = [
    u.APPROVED,
    u.PREQUALIFIED,
    u.PREQUALIFIED
  ];
  _declineCodes = [
    u.DECLINED,
    u.NOOFFER
  ];
  constructor(t) {
    this._context = t;
  }
  get firstResponse() {
    return this._context.firstResponse;
  }
  get lastResponse() {
    return this._context.lastResponse;
  }
  get allResponses() {
    return this._context.responses;
  }
  shouldSwitchProviders() {
    return !!this._context.lastResponse && (this._context.start === !0 || this._context.resume === !0);
  }
  nextProvider() {
    return this._context.approvedResponse?.provider ? this._context.approvedResponse.provider?.providerKey : this._context.lastResponse?.next?.provider?.providerKey;
  }
  nextApplyMode() {
    return this._context.approvedResponse?.applyMode ? this._context.approvedResponse.applyMode : this._context.lastResponse?.next?.applyMode;
  }
  isResumingNextProvider() {
    return this._context.resume === !0;
  }
  getResponseToContinueWith() {
    if (this._context.approvedResponse?.provider)
      return this._context.approvedResponse;
    const t = (i) => {
      const o = i.provider?.responseCode;
      return !!o && this._approvalCodes.includes(o);
    }, r = this._context.responses.find(t);
    if (r)
      return r;
    const n = (i) => {
      const o = i.provider?.responseCode;
      return !!o && this._declineCodes.includes(o);
    };
    return this._context.responses.every(n) ? this._context.responses[0] : this._context.lastResponse;
  }
  getResponseForProvider(t) {
    return this._context.responses.find(
      (r) => r.provider?.providerKey === t
    );
  }
  hasMultipleOffers() {
    const t = (r) => {
      const n = r.provider?.responseCode;
      return n === u.PREQUALIFIED || n === u.PREAPPROVED;
    };
    return this._context.responses.filter(t).length > 1;
  }
  hasSingleOffer() {
    const t = (r) => {
      const n = r.provider?.responseCode;
      return n === u.PREQUALIFIED || n === u.PREAPPROVED || n === u.APPROVED;
    };
    return this._context.responses.filter(t).length === 1;
  }
}
var si = /* @__PURE__ */ ((e) => (e.GROSS_MONTHLY = "gross_monthly", e.GROSS_ANNUAL = "gross_annual", e.NET_MONTHLY = "net_monthly", e.NET_ANNUAL = "net_annual", e))(si || {}), qe;
((e) => {
  function t(i) {
    return typeof i != "object" ? !1 : "contentType" in i && "data" in i;
  }
  e.isContent = t;
  function r(i) {
    return {
      contentType: "text/html",
      data: i
    };
  }
  e.fromHtml = r;
  function n(i, o) {
    const s = Ie(i);
    return {
      contentType: o ?? J.fromFilename(s.pathname) ?? "application/octet-stream",
      data: i
    };
  }
  e.fromUrl = n;
})(qe || (qe = {}));
var ht;
((e) => {
  function t(r) {
    return typeof r != "object" ? !1 : "content" in r && qe.isContent(r.content);
  }
  e.isContents = t;
})(ht || (ht = {}));
var Ge = /* @__PURE__ */ ((e) => (e.COMPONENT = "component", e.HTML = "html", e.IMAGE = "image", e.PDF = "pdf", e.UNKNOWN = "unknown", e.VNODE = "vnode", e))(Ge || {}), J = /* @__PURE__ */ ((e) => (e.COMPONENT = "application/component", e.HTML = "text/html", e.IMAGE_GIF = "image/gif", e.IMAGE_JPEG = "image/jpeg", e.IMAGE_PNG = "image/png", e.JSON = "application/json", e.JSON_UTF8 = "application/json;charset=utf-8", e.MARKDOWN = "text/markdown", e.PDF = "application/pdf", e.TEXT = "text/plain", e.UNKNOWN = "application/octet-stream", e.VNODE = "application/vnode", e.XML = "text/xml", e.XML_APPLICATION = "application/xml", e))(J || {});
const ai = {};
for (const e in J)
  ai[e] = J[e];
const ci = {
  gif: "image/gif",
  html: "text/html",
  jpeg: "image/jpeg",
  jpg: "image/jpeg",
  json: "application/json",
  md: "text/markdown",
  pdf: "application/pdf",
  png: "image/png",
  txt: "text/plain",
  xml: "text/xml"
  /* XML */
};
((e) => {
  function t(n) {
    const i = n?.split(".")?.pop()?.toLowerCase();
    return ci[i ?? ""] ?? "application/octet-stream";
  }
  e.fromFilename = t;
  function r(n) {
    if (n.startsWithIgnoreCase("data:"))
      return n.split(";")[0].split(":")[1] ?? null;
    const i = n.split("/");
    if (i.length < 2)
      return null;
    const o = decodeURIComponent(i.at(-1));
    return t(o);
  }
  e.fromUri = r;
})(J || (J = {}));
((e) => {
  function t(r) {
    switch (r?.toLowerCase()) {
      case "application/component":
        return "component";
      case "text/html":
        return "html";
      case "image/gif":
      case "image/jpeg":
      case "image/png":
        return "image";
      case "application/pdf":
        return "pdf";
      case "application/vnode":
        return "vnode";
      default:
        return "unknown";
    }
  }
  e.fromContentType = t;
})(Ge || (Ge = {}));
var li = /* @__PURE__ */ ((e) => (e[e.APPLY = 0] = "APPLY", e[e.PRINT = 1] = "PRINT", e))(li || {});
class ge {
  _type;
  _capabilities = [];
  constructor(t) {
    this._type = t, this._capabilities.push(
      0
      /* APPLY */
    ), t === ce.KIOSK && this._capabilities.push(
      1
      /* PRINT */
    );
  }
  get type() {
    return this._type;
  }
  get capabilities() {
    return [...this._capabilities];
  }
}
const di = () => {
  if (window.kiosk)
    return new ge(ce.KIOSK);
  const e = window.navigator.userAgent;
  return /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(e) ? new ge(ce.TABLET) : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
    e
  ) ? new ge(ce.MOBILE) : new ge(ce.DESKTOP);
};
function ia(e, t) {
  return e ? ui(e, t) : null;
}
function ui(e, t) {
  return {
    contentType: e.contentType ?? t ?? J.UNKNOWN,
    data: e.body
  };
}
var pi = /* @__PURE__ */ ((e) => (e.EMAIL = "email", e.PHONE = "phone", e))(pi || {});
class yt {
  relative;
  url;
  constructor(t) {
    this.relative = typeof t == "string" && t.indexOf("://") < 0, this.url = mi(t);
  }
  get standard() {
    switch (this.protocol) {
      case "http:":
      case "https:":
      case "mailto:":
      case "tel:":
        return !0;
      default:
        return !1;
    }
  }
  get hash() {
    return this.url.hash;
  }
  get host() {
    return this.url.host;
  }
  get hostname() {
    return this.url.hostname;
  }
  get href() {
    return this.url.href;
  }
  get origin() {
    return this.url.origin;
  }
  get password() {
    return this.url.password;
  }
  get pathname() {
    return this.url.pathname;
  }
  get port() {
    return this.url.port;
  }
  get protocol() {
    return this.url.protocol;
  }
  get search() {
    return this.url.search;
  }
  get searchParams() {
    return this.url.searchParams;
  }
  get username() {
    return this.url.username;
  }
  toString() {
    return this.relative ? this.url.pathname + this.url.search + this.url.hash : this.url.toString();
  }
}
const cr = () => window.location.protocol + "//" + window.location.host, fi = () => cr() + window.location.pathname, oa = (e) => {
  try {
    return Ie(e);
  } catch {
    return null;
  }
}, Ie = (e) => e instanceof yt ? e : new yt(e), mi = (e) => {
  if (e instanceof URL)
    return e;
  try {
    return new URL(e);
  } catch {
  }
  let t = e;
  if (e.indexOf("://") < 0) {
    const r = cr();
    e.startsWith("/") ? t = r.endsWith("/") ? r + e.substring(1) : r + e : t = r.endsWith("/") ? r + e : r + "/" + e;
  }
  return new URL(t);
}, hi = (e, t = "file") => {
  try {
    return Ie(e).pathname?.split("/")?.pop() ?? t;
  } catch {
    return t;
  }
}, Pe = (e, t) => {
  const r = Ie(e), n = r.searchParams;
  return Object.keys(t).forEach((i) => {
    const o = t[i];
    o != null && n.set(i, o);
  }), r;
}, sa = (e, t = "") => {
  const r = {
    sid: t,
    url: e
  };
  return "/api/v1/proxy?" + new URLSearchParams(r).toString();
}, He = "download", yi = (e, t) => {
  lr(e, t ?? hi(e, He));
}, vt = (e, t) => {
  const r = URL.createObjectURL(e);
  lr(r, t ?? He);
}, lr = (e, t, r = "_blank") => {
  const n = document.createElement("a");
  n.href = e, n.download = t ?? He, n.target = r, n.click();
}, vi = (e, t) => {
  e instanceof Promise ? e.then((r) => gt(r, t)) : "content" in e ? vi(e.downloadableContent ?? e.content, t) : gt(e, t);
}, gt = (e, t) => {
  e.data instanceof Blob ? vt(e.data, t) : typeof e.data != "string" || !gi(e.data) ? vt(
    new Blob([e.data], { type: e.contentType }),
    t
  ) : yi(e.data, t);
}, gi = (e) => e.startsWith("/") || e.startsWith("http://") || e.startsWith("https://") ? !0 : e.startsWith("data:");
async function dr(e) {
  const t = new TextEncoder().encode(e), r = await crypto.subtle.importKey("raw", t, "HKDF", !1, [
    "deriveKey"
  ]);
  return await crypto.subtle.deriveKey(
    {
      name: "HKDF",
      salt: new Uint8Array(0),
      info: new TextEncoder().encode("encryption"),
      hash: "SHA-256"
    },
    r,
    { name: "AES-GCM", length: 256 },
    !0,
    ["encrypt", "decrypt"]
  );
}
const Pi = (e = 12) => crypto.getRandomValues(new Uint8Array(e));
async function wi(e, t, r) {
  const n = await crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv: r
    },
    t,
    new TextEncoder().encode(e)
  );
  return Me.toString(n);
}
async function Ai(e, t, r) {
  const n = await crypto.subtle.decrypt(
    {
      name: "AES-GCM",
      iv: r
    },
    t,
    Me.toBinary(e)
  );
  return new TextDecoder().decode(n);
}
const Me = {
  toBinary: (e) => new Uint8Array(
    atob(e).split("").map((t) => t.charCodeAt(0))
  ),
  toString: (e) => {
    let t = "";
    const r = e.byteLength, n = 32768, i = Math.ceil(r / n);
    for (let o = 0; o < i; o++) {
      const s = e.slice(
        o * n,
        Math.min((o + 1) * n, r)
      );
      t += String.fromCharCode(...new Uint8Array(s));
    }
    return btoa(t);
  }
};
var Y = /* @__PURE__ */ ((e) => (e.CEIL = "ceil", e.FLOOR = "floor", e.HALF_EVEN = "halfeven", e))(Y || {});
const Si = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  roundingMode: "ceil"
}), Ri = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  roundingMode: "floor"
}), Pt = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  roundingMode: "halfExpand"
}), bi = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
  roundingMode: "ceil"
}), Ei = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
  roundingMode: "floor"
}), wt = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
  roundingMode: "halfExpand"
}), aa = (e) => e == null ? null : typeof e == "number" ? e : parseFloat(e), ca = (e, t = "cents", r = !1, n = "halfeven") => {
  if (e == null)
    return null;
  let i = typeof e == "string" ? parseFloat(e) : e;
  return t === "cents" && (i = i / 100), Ci(r, n).format(i);
}, Ee = (e, t, r = 0, n = 0) => {
  const i = Math.max(t - e, 0), o = Math.max(t - n, 0);
  return en(
    r,
    i,
    o
  );
};
function Ci(e, t) {
  if (e)
    switch (t) {
      case Y.CEIL:
        return Si;
      case Y.FLOOR:
        return Ri;
      case Y.HALF_EVEN:
        return Pt;
      default:
        return Pt;
    }
  else
    switch (t) {
      case Y.CEIL:
        return bi;
      case Y.FLOOR:
        return Ei;
      case Y.HALF_EVEN:
        return wt;
      default:
        return wt;
    }
}
const Ii = {
  isoDate: "YYYY-MM-DD",
  isoDateTime: "iso",
  localDate: "MM/DD/YYYY",
  localDateTime: "MM/DD/YYYY hh:mm A",
  localeDate: "MMMM DD, YYYY",
  localeDateNoLeadingZero: "MMMM D, YYYY"
}, la = (e, t, r = !1) => nn(e, t, {
  whole: !0,
  inclusive: r
});
function ur(e, t) {
  return on(e, t);
}
function da(e) {
  return ur(e, "localDate");
}
function ua(e) {
  return ur(e, "localeDate");
}
function pa(e, t, r) {
  const n = typeof r == "string" ? Ii[r] : void 0, i = typeof t == "string" ? dt(t, n) : dt(t), s = (() => {
    switch (e) {
      case "weekly":
        return i.add(7, "day");
      case "bi_weekly":
        return i.add(14, "day");
      case "monthly":
        return i.add(1, "month");
      case "yearly":
        return i.add(1, "year");
      default:
        return;
    }
  })();
  return typeof t == "string" ? s?.format(n) : s?.toDate();
}
const pr = 1, fa = (e, t = pr) => {
  const r = e.document;
  return e.innerHeight + Math.ceil(e.scrollY) + t >= r.body.scrollHeight;
}, ma = (e, t = pr) => e.clientHeight + Math.ceil(e.scrollTop) + t >= e.scrollHeight, fr = () => !!window.opener, mr = () => window.parent !== window, ze = () => fr() || mr();
function ha(e) {
  return e.toLowerCase().replace("_", "-");
}
const ya = (e, t = ".p-invalid") => {
  (e ?? document).querySelector(t)?.scrollIntoView({
    block: "center"
  });
}, va = () => {
  history.pushState(null, document.title, window.location.href);
}, v = k("provider", {
  state: () => ({
    currentProviderKey: void 0,
    primary: void 0,
    cascade: [],
    providers: {},
    openedPaymentPlan: void 0,
    viewedOffers: []
  }),
  getters: {
    applyResponses: (e) => {
      const t = st(e.providers);
      return at(t, "applyResponse").filter((r) => r != null);
    },
    currentProviderConfig: (e) => {
      const t = e.currentProviderKey;
      if (t != null)
        return e.providers[t]?.config ?? e.cascade.find((r) => r.providerKey === t);
    },
    preauthResponses: (e) => {
      const t = st(e.providers);
      return at(t, "preauthResponse").filter((r) => r != null);
    }
  },
  actions: {
    addDisclosures(e, t) {
      const r = this.requireProviderSession(e);
      r.disclosures = tn([...r.disclosures, t]);
    },
    findApplyResponse(e) {
      return this.requireProviderSession(e).applyResponse;
    },
    findDisclosures(e) {
      return this.requireProviderSession(e).disclosures ?? [];
    },
    findPreauthResponse(e) {
      return this.requireProviderSession(e).preauthResponse;
    },
    findProviderConfig(e) {
      return this.requireProviderSession(e).config;
    },
    findOverrides(e) {
      return this.requireProviderSession(e).overrides;
    },
    findPaymentPlan(e, t) {
      return this.findPaymentPlans(e).paymentPlans.find(
        (r) => r.providerPlanCode === t
      );
    },
    findPaymentPlans(e) {
      return this.requireProviderSession(e).paymentPlans ?? {
        paymentPlans: []
      };
    },
    findPurchaseDetails(e) {
      return this.requireProviderSession(e).purchaseDetails;
    },
    findResponseByMode(e, t) {
      return t == "full" ? this.findApplyResponse(e) : this.findPreauthResponse(e);
    },
    findStipulations(e) {
      return this.requireProviderSession(e).stipluations;
    },
    findTrustSessionId(e) {
      return this.requireProviderSession(e).trustSessionId;
    },
    initializeCascade(e) {
      this.cascade = e;
      for (const t of e) {
        const r = this.requireProviderSession(t.providerKey);
        r.config = t;
      }
    },
    initializeProvider(e) {
      const { providerKey: t, preauthResponse: r, applyResponse: n, paymentPlans: i } = e, o = this.requireProviderSession(t);
      r && (o.preauthResponse = r), n && (o.applyResponse = n), i?.length && (o.paymentPlans = {
        paymentPlans: i
      });
    },
    requireProviderSession(e) {
      let t = this.providers[e];
      return t == null && (t = {
        disclosures: [],
        providerKey: e,
        stipluations: []
      }, this.providers[e] = t), t.providerKey ??= e, t.config ??= this.cascade.find(
        (r) => r.providerKey === e
      ), t;
    },
    switchProvider(e) {
      this.currentProviderKey = e;
    },
    setTrustSessionId(e, t) {
      const r = this.requireProviderSession(e);
      r.trustSessionId = t;
    },
    setPaymentPlans(e, t) {
      const r = this.requireProviderSession(e);
      r.paymentPlans = t;
    },
    setPreauthResponse(e) {
      const { providerKey: t } = e, r = this.requireProviderSession(t);
      r.preauthResponse = e, r.stipluations = e.stipulations ?? [];
    },
    setApplyResponse(e) {
      const { providerKey: t } = e, r = this.requireProviderSession(t);
      r.applyResponse = e, r.stipluations = e.stipulations ?? [];
    },
    resetProvider(e) {
      delete this.providers[e];
    },
    setPurchaseDetails(e, t) {
      const r = this.requireProviderSession(e);
      r.purchaseDetails = t;
    },
    setStipulations(e, t) {
      const r = this.requireProviderSession(e);
      r.stipluations = t;
    },
    addOverrides(e, t) {
      const r = this.requireProviderSession(e);
      r.overrides = t;
    },
    addViewedOffer(e) {
      this.viewedOffers.push(e);
    },
    updateStipulation(e, t) {
      const r = this.requireProviderSession(e), n = r.stipluations.findIndex(
        (i) => i.id === t.id
      );
      n !== -1 && (r.stipluations[n] = t);
    }
  }
}), W = k("locale", {
  state: () => ({
    experienceType: void 0,
    group: "versatile",
    language: "en",
    theme: "versatile"
  }),
  getters: {
    locale: (e) => `${e.group}_${e.language}`
  },
  actions: {
    doInitialize(e) {
      this.experienceType = e.experienceType, this.group = e.groupId, this.theme = e.themeId ?? e.groupId;
    }
  }
}), w = k("application", {
  state: () => ({
    application: void 0,
    jointSelectionEnabled: void 0,
    originalApplication: void 0,
    applyMode: void 0,
    applyStage: void 0,
    primaryProviderApplyMode: void 0,
    previousResponses: [],
    selectedPlan: void 0,
    stipulations: [],
    payments: []
  }),
  getters: {
    previousLender: (e) => (
      /**
       * Find the provider response that caused the transition to
       * the current lender.
       *
       * @param currentLender
       */
      ((t) => e.previousResponses.find(
        ({ next: r }) => r?.provider?.providerKey === t
      )?.provider)
    ),
    currentProviderResponse: (e) => (t) => {
      const r = e.previousResponses.find(
        ({ provider: n }) => n?.providerKey === t
      );
      return r?.provider !== void 0 ? r : void 0;
    },
    previousProviderResponse: (e) => (t) => {
      const r = e.previousResponses.find(
        ({ next: n }) => n?.provider?.providerKey === t
      );
      return r?.provider !== void 0 ? r : void 0;
    }
  },
  actions: {
    switchApplyMode(e) {
      this.applyMode = e, this.applyStage = e;
    },
    setApplicationValues(e) {
      const t = this.application = this.application ?? {};
      for (const r in e)
        ct(t, r, e[r]);
      this.application = t;
    },
    getApplicationValue(e) {
      const t = this.application;
      return t ? Jt(t, e) : void 0;
    },
    setApplicationValue(e, t) {
      this.application = ct(this.application ?? {}, e, t);
    },
    addResponse(e) {
      e.provider && !e.provider.applicantType && (e.provider.applicantType = Q.PRIMARY), this.previousResponses.push(e);
    },
    updateStipulation(e) {
      this.stipulations = this.stipulations.map((t) => t.id === e.id ? e : t);
    },
    addPayment(e) {
      this.payments.push(e);
    }
  }
}), O = k("session", {
  state: () => ({
    id: void 0,
    flowSessionId: void 0,
    flowType: void 0,
    environment: void 0,
    properties: {},
    status: "IDLE",
    testCase: void 0,
    testCases: [],
    timeout: {},
    extensions: [],
    resume: void 0,
    storefrontSdk: void 0
  }),
  getters: {
    sessionId: (e) => e.id,
    isActive: (e) => !!e.id && e.status === "ACTIVE",
    needsRestore: (e) => !!e.id && e.status === "RESTORE_NEEDED",
    timedout: (e) => e.status === "TIMED_OUT",
    property: (e) => (t) => e.properties[t],
    providerResume: (e) => {
      const t = e.resume;
      return t && "applicationId" in t ? t : void 0;
    },
    waterfallResume: (e) => {
      const t = e.resume;
      return t && "waterfallSessionId" in t ? t : void 0;
    }
  },
  actions: {
    doRestore(e) {
      this.id = e, this.status = "RESTORE_NEEDED";
    },
    doTimeout() {
      this.status = "TIMED_OUT";
    },
    doInitialize(e) {
      this.id = e.webSessionId, this.environment = e.environment, this.flowSessionId = e.flowSessionId, this.flowType = e.flowType, this.properties = e.properties, this.testCases = e.testCases ?? [], this.testCase = void 0, this.extensions = e.extensions || [], this.storefrontSdk = e.storefrontSdk, this.timeout = {
        timeoutAfterMillis: e.sessionTimeoutMillis,
        warnAfterMillis: Math.max(
          0,
          e.sessionTimeoutMillis - e.sessionWarnCountdownMillis
        )
      }, this.resume = e.resume, this.status = "ACTIVE";
    },
    findExtensionsByFlowPosition(e) {
      return this.extensions.filter((t) => {
        let r = !1;
        return t.featureId == "prove" && (r = t.properties.skipUi), t.flowPosition == e && !r;
      });
    },
    findExtensionById(e) {
      return this.extensions.find(
        (t) => t.featureId == e
      );
    },
    updateResume(e) {
      this.resume = e;
    }
  }
}), hr = "vst.appState", At = () => {
  Object.keys(sessionStorage).forEach((e) => {
    e.startsWith(hr) && sessionStorage.removeItem(e);
  });
}, Mi = async (e, t) => {
  const r = e.$state, n = await dr(t), i = Pi(), s = {
    state: await wi(JSON.stringify(r), n, i),
    iv: Me.toString(i.buffer)
  };
  sessionStorage.setItem($e(e), JSON.stringify(s));
}, Oi = async (e, t) => {
  const r = sessionStorage.getItem($e(e));
  if (!r)
    throw new Error(`Unable to find ${$e(e)} in session store`);
  try {
    const n = JSON.parse(r), i = Me.toBinary(n.iv), o = await dr(t), s = await Ai(n.state, o, i), a = JSON.parse(s);
    e.$patch(a), await x();
  } catch (n) {
    throw new Error(`Unable to read app state from session storage - ${n}`);
  }
};
function $e(e) {
  return `${hr}.${e.$id}`;
}
const Ve = k("error", {
  state: () => ({
    error: void 0,
    info: void 0
  })
}), j = k("field", {
  state: () => ({
    fields: {},
    fieldArray: [],
    fieldsById: {},
    fieldGroupRules: [],
    fieldProviderKeys: []
  }),
  getters: {
    fieldByPath: (e) => (t) => e.fields[t],
    fieldById: (e) => (t) => e.fieldsById[t],
    fieldCount: (e) => Ue(e.fields).length
  },
  actions: {
    addFields(e) {
      const t = /* @__PURE__ */ new Set(), r = [];
      this.fieldArray.forEach((n) => {
        t.add(n.id);
      }), e.forEach((n) => {
        this.fields[n.path] = n, this.fieldsById[n.id] = n, t.has(n.id) || r.push(n);
      }), r.length > 0 && this.fieldArray.push(...r);
    },
    setFields(e) {
      this.fields = {}, this.fieldArray = e, this.fieldsById = {}, e.forEach((t) => {
        this.fields[t.path] = t, this.fieldsById[t.id] = t;
      });
    },
    getFieldsByPath(...e) {
      const t = [];
      return e.forEach((r) => {
        const n = this.fieldByPath(r);
        n && t.push(n);
      }), t;
    },
    removeFieldsByPath(...e) {
      e.forEach((t) => {
        const r = this.fieldByPath(t);
        r && (delete this.fields[r.path], delete this.fieldsById[r.id]);
      });
    }
  }
}), Ye = k("merchant", {
  state: () => ({
    legalName: void 0,
    location: void 0,
    name: void 0,
    supportPhoneNumber: void 0,
    logoConfig: void 0,
    splashConfig: void 0,
    siteConfig: void 0
  }),
  actions: {
    doInitialize(e) {
      this.name = e.merchant?.name, this.legalName = e.merchant?.legalName, this.location = e.merchant?.location, this.logoConfig = e.merchant?.logoConfig, this.splashConfig = e.merchant?.splashConfig, this.supportPhoneNumber = e.merchant?.supportPhoneNumber, this.siteConfig = e.merchant?.siteConfig;
    }
  }
}), ga = k("navigation", {
  state: () => ({
    backPosition: void 0
  })
}), _ = k("app", {
  getters: {
    applyMode() {
      return w().applyMode;
    },
    currentProviderKey() {
      return v().currentProviderKey;
    },
    flowSessionId() {
      return O().flowSessionId;
    },
    group() {
      return W().group;
    },
    applyResponse() {
      const e = v();
      return (t) => e.findApplyResponse(t);
    },
    preauthResponse() {
      const e = v();
      return (t) => e.findPreauthResponse(t);
    }
  },
  actions: {
    resetAll() {
      const e = Se();
      if (!e)
        throw new Error("There is no active Pinia instance");
      e._s.forEach((t) => {
        ["merchant", "locale"].includes(t.$id) || t.$reset();
      }), At();
    },
    clearedStoredAppStates() {
      At();
    },
    async persistStoreToSession(e) {
      const t = Se();
      if (!t)
        throw new Error("There is no active Pinia instance");
      for (const r of t._s.values())
        await Mi(r, e);
    },
    async reloadStoreFromSession(e) {
      const t = Se();
      if (!t)
        throw new Error("There is no active Pinia instance");
      for (const r of t._s.values())
        await Oi(r, e);
    }
  }
}), Ti = () => {
  const e = Se();
  if (!e)
    throw new Error("Unable to find Active Pinia!");
  e.use(
    mn({
      key: (t) => `__persisted__${t}`,
      storage: window.sessionStorage,
      auto: !0
    })
  );
}, Pa = (e, t) => {
  const r = _(), n = tr(e, t);
  return r.$onAction((i) => {
    i.name === "resetAll" && n.clear();
  }), n;
}, wa = (e, t = {}) => {
  const r = new Intl.NumberFormat("en-US", {
    style: "percent",
    minimumFractionDigits: t.minimumFractionDigits ?? 2,
    maximumFractionDigits: t.maximumFractionDigits ?? 2
  }), n = typeof e == "string" ? parseFloat(e) : e;
  return r.format(n > 1 ? n / 100 : n);
}, Aa = (e) => Promise.reject(new Error(e)), St = /* @__PURE__ */ Object.create(null);
function Sa(e, t) {
  if (!t)
    return e;
  const r = {};
  Object.keys(t).forEach((n) => {
    const i = t[n];
    typeof i == "number" ? r[n] = String(i) : Array.isArray(i) ? r[n] = i.map((o) => o.toString()) : i != null && (r[n] = i);
  });
  try {
    const n = St[e] || (St[e] = hn(e));
    return typeof t.pathMatch == "string" && (t[0] = t.pathMatch), n(r);
  } catch {
    return "";
  } finally {
    delete t[0];
  }
}
const Ra = (e, t, r = 0, n = e?.length, i) => e && _i(e, t, r, n ?? e.length, i), _i = (e, t, r = 0, n = e.length, i) => {
  if (e = e ?? "", r < 0 && (r = e.length + r), n < 0 && (n = e.length + n), r < 0 && (r = 0), (n < 0 || n > e.length) && (n = e.length), r >= e.length)
    return e;
  const o = e.split("");
  for (let s = r; s < n; s++)
    i?.test(o[s]) || (o[s] = t);
  return o.join("");
}, Rt = (e) => e == null ? !0 : typeof e == "string" ? e.trim().length === 0 : !1, ba = (e = "Not implemented") => {
  throw new Error("TODO: " + e);
}, yr = () => {
  let e = (/* @__PURE__ */ new Date()).getTime(), t = performance?.now && performance.now() * 1e3 || 0;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(r) {
    let n = Math.random() * 16;
    return e > 0 ? (n = (e + n) % 16 | 0, e = Math.floor(e / 16)) : (n = (t + n) % 16 | 0, t = Math.floor(t / 16)), (r === "x" ? n : n & 3 | 8).toString(16);
  });
}, Ea = (e) => {
  if (e == null || /[^0-9-\s]+/.test(e))
    return !1;
  switch (e.substring(0, 1)) {
    case "3":
      return Fi(e);
    case "4":
      return Di(e);
    case "5":
      return Ni(e);
    case "6":
      return xi(e);
    default:
      return pe(e);
  }
}, Di = (e) => e.length === 16 && pe(e), Fi = (e) => e.length === 15 && pe(e), Ni = (e) => e.length === 16 && pe(e), xi = (e) => e.length === 16 && pe(e), pe = (e) => {
  let t = 0, r = 0, n = !1;
  for (let i = e.length - 1; i >= 0; i--) {
    const o = e.charAt(i);
    r = parseInt(o, 10), n && (r *= 2) > 9 && (r -= 9), t += r, n = !n;
  }
  return t % 10 === 0;
}, fe = (e, t) => (t && (t.value = !1), async (...r) => {
  try {
    return t && (t.value = !0), await e(...r);
  } finally {
    t && (t.value = !1);
  }
});
var T = /* @__PURE__ */ ((e) => (e[e.TRACE = 0] = "TRACE", e[e.DEBUG = 1] = "DEBUG", e[e.INFO = 2] = "INFO", e[e.WARN = 3] = "WARN", e[e.ERROR = 4] = "ERROR", e))(T || {});
const Li = (e) => {
  if (e.stack) {
    const t = e.stack.split(`
`), r = t[0]?.startsWith("Error") ? 4 : 3, n = t[r];
    if (n != null)
      return n.trim().replace("(", "").replace(")", "");
  }
}, Ui = (e) => {
  if (e.includes("at "))
    return e.substring(e.indexOf("at ") + 3, e.lastIndexOf(" ")).split(".").reverse()[0];
  if (e.includes("@"))
    return e.substring(0, e.indexOf("@"));
}, Ki = (e) => {
  const t = e.split(":").reverse(), r = t[2];
  if (r == null)
    return;
  const n = r.substring(
    Math.max(
      r.lastIndexOf("/"),
      r.lastIndexOf("\\")
    ) + 1
  ).split("?")[0], i = t[1];
  return {
    fileName: n,
    lineNumber: i
  };
};
class Bi {
  constructor(t, r, n) {
    this._name = t, this._isProduction = r, this._appenders = n;
  }
  _name;
  _isProduction;
  _appenders;
  trace(t, ...r) {
    this.log(T.TRACE, t, r);
  }
  debug(t, ...r) {
    this.log(T.DEBUG, t, r);
  }
  info(t, ...r) {
    this.log(T.INFO, t, r);
  }
  warn(t, ...r) {
    this.log(T.WARN, t, r);
  }
  error(t, ...r) {
    this.log(T.ERROR, t, r);
  }
  getCallerInfo() {
    const t = new Error();
    if (!t.stack)
      try {
        throw t;
      } catch {
      }
    if (t.stack)
      try {
        const r = Li(t);
        if (r == null)
          return;
        const n = Ui(r), i = Ki(r);
        return {
          functionName: n,
          fileName: i?.fileName,
          lineNumber: i?.lineNumber
        };
      } catch (r) {
        f(this._isProduction) && console.debug(
          "vue-logger-plugin :: failed to determine caller function info:",
          r
        );
      }
  }
  log(t, r, n) {
    const i = [r, ...n], o = this.getCallerInfo();
    o && i.unshift(
      `[${o.fileName}:${o.functionName}:${o.lineNumber}]`
    ), this.append({
      name: f(this._name),
      level: t,
      args: i,
      caller: o
    });
  }
  append(t) {
    this._appenders.forEach((r) => r.append(t));
  }
}
class ki {
  append(t) {
    switch (t.level) {
      case T.TRACE:
        console.trace(t.name, ...t.args);
        break;
      case T.DEBUG:
        console.debug(t.name, ...t.args);
        break;
      case T.INFO:
        console.info(t.name, ...t.args);
        break;
      case T.WARN:
        console.warn(t.name, ...t.args);
        break;
      case T.ERROR:
        console.error(t.name, ...t.args);
        break;
    }
  }
}
class qi {
  _client;
  _store;
  constructor(t, r) {
    this._client = t, this._store = r;
  }
  append(t) {
    this._client.log({
      clientDateTime: (/* @__PURE__ */ new Date()).toISOString(),
      level: this.buildLevel(t),
      message: this.buildMessage(t),
      name: t.name,
      source: "versatile-credit-apply",
      tags: this.buildTags()
    }).catch((r) => {
      console.error(r);
    });
  }
  buildTags() {
    const t = [], r = this._store.group;
    r && t.push(`[group=${r}]`);
    const n = this._store.currentProviderKey;
    n && t.push(`[providerKey=${n}]`);
    const i = this._store.applyMode;
    return i && t.push(`[applyMode=${i}]`), t.filter((o) => o !== "");
  }
  buildLevel(t) {
    switch (t.level) {
      case T.TRACE:
        return oe.TRACE;
      case T.DEBUG:
        return oe.DEBUG;
      case T.INFO:
        return oe.INFO;
      case T.WARN:
        return oe.WARN;
      case T.ERROR:
        return oe.ERROR;
    }
  }
  buildMessage(t) {
    let r = "";
    return t.args.forEach((n) => {
      r += " " + this.argToString(n);
    }), r.trim();
  }
  argToString(t) {
    return t instanceof Error ? t.message : typeof t == "object" ? JSON.stringify(t) : String(t);
  }
}
class H {
  store;
  constructor(t) {
    this.store = t;
  }
  get applyMode() {
    const t = this.store.applyMode;
    if (!t)
      throw new Error("Invalid Application State");
    return t;
  }
  get providerModule() {
    return U(this.provider);
  }
  get provider() {
    const t = this.store.currentProviderKey;
    if (!t)
      throw new Error("Invalid Application State");
    return t;
  }
  get providerKey() {
    return N(this.provider);
  }
}
class Gi extends H {
  client;
  constructor(t, r) {
    super(r), this.client = t;
  }
  async getQuiz() {
    const t = await this.client.loadQuiz(this.provider);
    return t.questions = lt(t.questions || [], ["sequence"]), t.questions.forEach((r) => {
      r.choices = lt(r.choices || [], ["sequence"]);
    }), t;
  }
  answerQuiz(t) {
    return this.client.answerQuiz(this.provider, t);
  }
  lookupApplication() {
    return this.client.checkApplication(this.provider);
  }
}
class vr extends H {
  client;
  constructor(t, r) {
    super(r), this.client = t;
  }
  async sendVerificationCode(t, r) {
    return await this.client.sendVerificationCode(
      r ?? this.provider,
      t
    );
  }
  async verifyVerificationCode(t, r) {
    return await this.client.verifyVerificationCode(
      r ?? this.provider,
      t
    );
  }
}
const Qe = () => {
  const e = _(), t = R(
    () => `ApplicationService [${e.currentProviderKey}]`
  );
  return new le(g(), e, t);
}, te = () => {
  const e = v();
  return h(() => e.currentProviderKey);
}, gr = () => {
  const e = te();
  return h(() => {
    const t = e.value;
    if (!t)
      throw Error("Provider is not set in the store!");
    return t;
  });
}, Ca = (e) => {
  const t = te(), r = () => e ? f(e) : void 0;
  return h(() => {
    const n = r() ?? t.value;
    return n ? N(n) : void 0;
  });
}, Ia = () => {
  const e = v(), t = gr(), r = h(() => e.cascade || []), n = h(
    () => r.value.find(
      (i) => N(i.providerKey) === N(t.value)
    )
  );
  return h(() => {
    if (!n.value)
      return !1;
    const i = r.value.indexOf(
      n.value
    );
    return i > -1 && i < r.value.length - 1;
  });
};
function Pr(e) {
  const t = v();
  return h(() => {
    const r = f(e);
    if (!r)
      return;
    const n = t.currentProviderKey;
    return r === n ? t.currentProviderConfig : t.findProviderConfig(r);
  });
}
const Ma = () => {
  const e = te();
  return Pr(e);
}, Oa = () => {
  const e = j();
  return h(() => e.fieldGroupRules);
}, Ta = (e) => {
  const t = j();
  return h(() => {
    const r = f(e);
    return r ? t.fieldByPath(r) : void 0;
  });
}, $i = () => {
  const e = g();
  return (t) => e.getInvalidFields([f(t)]);
}, _a = (e) => {
  const t = j();
  return h(() => t.fieldByPath(f(e)) != null);
}, we = (e) => {
  const t = e.id.lastIndexOf(".");
  return t === -1 ? e.id : e.id.substring(0, t);
}, Vi = (e, t) => t?.waterfallStatus !== "completed" || t.waterfallOutcomeType !== "offer_present" && t.waterfallOutcomeType !== "additional_info_required" ? !1 : t.waterfallProviderKey === e, Wi = (e, t) => t.findIndex((r) => r.endsWith(".*") ? e.path.startsWith(r.substring(0, r.length - 2)) : e.path === r) > -1, ji = (e, t, r) => {
  const n = rn(t, (s) => s.path), i = /* @__PURE__ */ new Set();
  return t.forEach((s) => {
    s.rules.forEach((a) => {
      if (a.id === "requiredIf") {
        const c = e.find(({ id: l }) => l == a.fieldId);
        c != null && we(s) == we(c) && i.add(c.id);
      }
      a.id === "requiredIfNotNullIn" && a.fieldDescriptors.forEach((c) => {
        we(s) == we(c) && i.add(c.id);
      });
    });
  }), [...e.filter((s) => n[s.path] == null).filter(
    (s) => i.has(s.id) || Wi(s, r)
  ), ...t];
}, Da = () => {
  const e = $i(), t = w(), r = v(), n = O(), i = j();
  return async (o, s) => {
    const a = f(o), c = t.previousResponses.length > 0, l = !!r.findPreauthResponse(a);
    if (c || l || Vi(f(o), n.waterfallResume)) {
      const d = await e(o);
      i.setFields(
        ji(i.fieldArray, d.fields, s || [])
      ), i.fieldGroupRules = d.fieldGroupRules, i.fieldProviderKeys = [f(o)];
    }
    return i.fieldCount > 0;
  };
}, Hi = (e) => h(() => {
  const t = f(e);
  return t ? U(t) : void 0;
}), wr = (e = {}) => {
  const t = w(), r = v(), n = j();
  return (i) => (t.switchApplyMode(i.applyMode), n.setFields(i.fields), n.fieldGroupRules = i.fieldGroupRules, n.fieldProviderKeys = i.fieldProviderKeys, r.currentProviderKey = i.providerKey, e.overwriteCascade && r.initializeCascade(i.providers), r.primary?.providerKey === i.providerKey && (t.primaryProviderApplyMode = i.applyMode), new zi(i.providerKey, !1));
}, Je = () => {
  const e = R("useSwitchProvider"), t = g(), r = wr();
  return async (n) => {
    const { providerKey: i, applyMode: o } = n;
    e.info(
      `Switching to provider: ${i} and apply mode: ${o}`
    );
    const s = await t.startProviderApply(i, o);
    return r(s);
  };
};
class zi {
  constructor(t, r) {
    this._providerKey = t, this._resume = r;
  }
  _providerKey;
  _resume;
  get providerKey() {
    return this._providerKey;
  }
  get resume() {
    return this._resume;
  }
}
const Fa = () => new V(
  g(),
  _(),
  Qe(),
  wr()
), Na = () => new Io(g(), _()), xa = () => {
  const e = g(), t = _();
  return new Mo(e, t);
}, La = () => {
  const e = g(), t = _();
  return new Oo(e, t);
}, Ua = () => new Co(g()), Ar = () => new vr(g(), _()), Yi = () => {
  const e = _();
  return new Re(g(), e);
}, Ka = () => {
  const e = g(), t = v();
  return async (r, n) => {
    const { status: i } = await e.getProviderStipulationStatus(
      r,
      n.id
    );
    t.updateStipulation(r, {
      ...n,
      status: i
    });
  };
}, Qi = (e, t, r) => {
  X().reportCustomError(e, t, r, !0);
}, B = (e) => {
  if (e == null)
    return;
  const t = X();
  (e instanceof Error || typeof e == "string") && t.reportError(e);
}, Ji = (e) => {
  const t = w();
  return h(() => {
    const r = f(e), n = t.application;
    return r === Q.PRIMARY ? n?.primary : n?.joint;
  });
}, Ba = (e, t) => {
  const r = g(), n = R("useApplicationDocuments"), i = async () => {
    const d = f(e), p = f(t) ?? [];
    return d ? (await r.getApplicationDocuments(
      d,
      ...p
    )).documents.reduce(
      (P, b) => ({ ...P, [b.type]: b }),
      {}
    ) : {};
  }, { error: o, isLoading: s, isReady: a, state: c, execute: l } = ue(
    i,
    {},
    {
      onError: (d) => n.error(
        `Failed trying to fetch application documents for provider: ${f(e)}`,
        d
      )
    }
  );
  return {
    error: o,
    isLoading: s,
    isReady: a,
    state: c,
    refresh: l
  };
}, ka = () => {
  const e = g();
  return {
    confirmSelectedPlan: async (r, n) => e.confirmPaymentPlan(r, n)
  };
}, Zi = (e) => {
  const t = v(), r = te();
  return h(() => {
    const n = f(e) ?? r.value;
    return n ? t.findApplyResponse(n) ?? t.findPreauthResponse(n) : void 0;
  });
}, Xi = () => {
  const e = w();
  return h(() => e.application?.downPaymentAmountCents ?? void 0);
}, eo = (e, t) => {
  const r = w(), n = v(), i = () => {
    const o = f(e), s = N(o);
    return s === "fortiva_standard" ? n.findApplyResponse(o) ? "agreement" : "credit_terms" : s === "hfd_standard" ? "esignDoc" : r.applyMode ?? "full";
  };
  return h(() => (t ? f(t).documentType : void 0) ?? i());
}, to = (e) => h(() => {
  switch (e ? f(e).contentType : void 0) {
    case "gif":
      return "image/gif";
    case "jpeg":
      return "image/jpeg";
    case "png":
      return "image/png";
    case "pdf":
      return "application/pdf";
    case "html":
      return "text/html";
    case "text":
      return "text/plain";
    default:
      return;
  }
}), ro = (e) => {
  const t = g(), r = to(e);
  return h(() => {
    const n = {
      sid: t.sessionId ?? ""
    };
    return r.value && (n.contentType = r.value), new URLSearchParams(n).toString();
  });
}, qa = (e, t) => {
  const r = g(), n = eo(e, t), i = ro(t);
  return h(() => {
    const o = f(e), s = N(o), a = `${r.baseUrl}/api/v1/providers/${encodeURIComponent(o)}`;
    return s === "fortiva_standard" ? `${a}/documents/${n.value}?${i.value}` : `${a}/application/terms/${n.value}?${i.value}`;
  });
}, Ga = () => {
  const e = w();
  return h(() => e.application?.installationAddressSameAsPrimary ? e.application?.primary?.homeAddress : e.application?.installationLocation?.address);
};
function $a() {
  const e = w();
  return h(() => !!Zt(e.previousResponses)?.next?.topoff?.amountCents);
}
const Va = () => {
  const e = w(), t = v();
  return h(() => {
    const r = Zt(e.previousResponses)?.next;
    return r?.provider?.providerKey === t.currentProviderKey ? void 0 : r;
  });
}, Wa = () => {
  const e = g(), t = R("useOfferLookup"), r = async () => {
    const l = f(no());
    return await e.offerLookup(l);
  }, { error: n, isLoading: i, isReady: o, state: s, execute: a, executeImmediate: c } = ue(
    r,
    {},
    {
      immediate: !1,
      onError: (l) => {
        t.error("Offers not found ", l);
      }
    }
  );
  return {
    error: n,
    isLoading: i,
    isReady: o,
    state: s,
    refresh: a,
    submit: c
  };
}, no = () => {
  const e = w();
  return {
    primary: {
      firstName: e.getApplicationValue("primary.firstName"),
      lastName: e.getApplicationValue("primary.lastName"),
      dateOfBirth: e.getApplicationValue("primary.dateOfBirth"),
      ssn: e.getApplicationValue("primary.ssn"),
      mobilePhone: e.getApplicationValue("primary.mobilePhone")
    }
  };
}, ja = () => {
  const e = R("use-patch-application.ts"), t = Qe();
  return () => (e.info("Patching Application"), t.patchApplication());
}, Ha = (e) => {
  const t = v(), r = te();
  return h(() => {
    const n = f(e) ?? r.value;
    return n ? t.findPreauthResponse(n) : void 0;
  });
}, de = (e) => {
  const t = w(), r = v();
  return h({
    get: () => {
      const n = f(e);
      if (n) {
        const i = r.findOverrides(n);
        if (i?.purchaseAmountCents)
          return i.purchaseAmountCents;
      }
      return t.application?.purchaseAmountCents ?? void 0;
    },
    set: (n) => {
      const i = f(e);
      if (i) {
        const o = r.findOverrides(i);
        r.addOverrides(i, {
          ...o,
          purchaseAmountCents: n
        });
        return;
      }
      t.application && (t.application.purchaseAmountCents = n);
    }
  });
}, za = () => {
  const e = g();
  return async (t) => e.publishUserOptOutProviderBypass(t);
}, Ya = () => {
  const e = g();
  return async () => e.publishCascadeConsent({});
};
function Qa(e) {
  if (e.standard)
    return {
      type: "link",
      value: e.href,
      params: {}
    };
  const t = e.protocol, r = io(e.searchParams);
  return t === "route:" ? {
    type: "route",
    value: e.pathname,
    params: r
  } : {
    type: t + e.pathname,
    value: e.pathname,
    params: r
  };
}
function io(e) {
  const t = {};
  return e.forEach((r, n) => {
    t[n] = r;
  }), t;
}
const oo = (e) => ({
  type: "checkout.transition",
  data: {
    applicationId: e.applicationId,
    resume: e.applicationWasResumed,
    token: e.token,
    from: "apply"
  },
  source: "vcredit"
}), so = (e) => ({
  type: "start",
  data: {
    flowId: e.flow
  },
  source: "vcredit"
}), ao = (e) => {
  const t = () => {
    switch (e.outcome) {
      case "completed":
      case "pending":
        return "completed";
      case "canceled":
        return "canceled";
      case "timeout":
        return "abandoned";
    }
  };
  return {
    type: "end",
    data: {
      flowId: e.flow,
      exitStatus: t()
    },
    source: "vcredit"
  };
}, co = (e) => ({
  type: "error",
  data: {
    category: e.category,
    cloudRequestId: e.cloudRequestId,
    code: e.code,
    message: e.message,
    httpStatusCode: e.httpStatusCode,
    httpMethod: e.httpMethod?.toLowerCase(),
    path: e.path
  },
  source: "vcredit"
}), lo = (e) => {
  const r = w().application, i = v().findProviderConfig(e.response.providerKey), o = () => i?.providerProduct?.replace(/-/g, "_")?.toLowerCase(), s = () => {
    switch (i?.providerProductType) {
      case "credit":
        return "revolving_credit";
      case "lease":
        return "lease";
      case "loan":
        return "loan";
      default:
        return;
    }
  }, a = () => {
    switch (e.response.responseCode) {
      case u.OPEN:
      case u.APPROVED:
        return "approved";
      case u.NOOFFER:
        return "nooffer";
      case u.DECLINED:
        return "declined";
      case u.ERROR:
        return "error";
      case u.PENDING:
      case u.SUBMITTED:
        return "pending";
      case u.PREAPPROVED:
      case u.PREQUALIFIED:
        return "prequalified";
    }
  };
  return {
    type: "application.decision",
    // @ts-expect-error need to populate metadata
    data: {
      sessionId: e.sessionId,
      agreedToCascade: r?.hasAgreedToCascade,
      amount: e.response.approvedAmountCents,
      applicationId: e.response.versatileApplicationId,
      accountId: e.response.versatileAccountId,
      status: a(),
      providerId: e.response.providerId,
      providerReferenceNumber: e.response.applicationId ?? e.response.applicationReferenceNumber,
      providerProductId: o(),
      productType: s(),
      message: e.response.errors?.[0]?.errorMessage
    },
    source: "vcredit"
  };
}, uo = (e) => ({
  type: "page.view",
  data: {
    path: e.toUrl
  },
  source: "vcredit"
}), po = (e) => {
  switch (e.type) {
    case "checkout":
      return oo(e);
    case "decision":
      return lo(e);
    case "end":
      return ao(e);
    case "error":
      return co(e);
    case "start":
      return so(e);
    case "page-view":
      return uo(e);
    default:
      return;
  }
}, fo = (e) => (r) => {
  const n = po(r);
  n && e.postMessage(n, "*");
}, mo = (e) => (t) => e.info("Event:", t), ho = () => (e) => {
  const t = K.getInstance();
  switch (e.type) {
    case "start":
      t.push({
        event: "app.start",
        event_start_flow: e.flow
      });
      break;
    case "end":
      t.push({
        event: "app.end",
        event_end_flow: e.flow,
        event_end_outcome: e.outcome
      });
      break;
    case "error":
      t.push({
        event: "app.error",
        event_error_code: e.code,
        event_error_message: e.message,
        event_error_category: e.category
      });
      break;
    case "decision":
      t.push({
        event: "app.decision",
        event_decision_provider: e.response.providerId
      });
      break;
    case "checkout":
      t.push({
        event: "app.checkout"
      });
      break;
  }
}, yo = () => {
  const e = g(), t = O();
  return (r) => {
    t.isActive && r.type === "page-view" && e.publishSessionPageView({
      toUrl: r.toUrl,
      fromUrl: r.fromUrl
    }).catch((n) => B(n));
  };
}, vo = () => {
  const e = document.createElement("meta");
  return e.name = "session-id", document.head.appendChild(e), e;
}, bt = () => document.querySelector(
  "meta[name=session-id]"
) ?? vo(), go = () => {
  const e = O(), t = W();
  return (r) => {
    switch (r.type) {
      case "start": {
        Z(`vca.${r.type}`, {
          "app.session": e.flowSessionId,
          "app.group": t.group,
          "event.flow": r.flow
        });
        const n = bt();
        n.content = e.flowSessionId ?? "";
        break;
      }
      case "error": {
        Z(`vca.${r.type}`, {
          "app.session": e.flowSessionId,
          "app.group": t.group,
          "event.category": r.category,
          "event.code": r.code,
          "event.message": r.message,
          "event.request": r.cloudRequestId
        });
        break;
      }
      case "checkout": {
        Z(`vca.${r.type}`, {
          "app.session": e.flowSessionId,
          "app.group": t.group,
          "event.application": r.applicationId,
          "event.resumed": r.applicationWasResumed
        });
        break;
      }
      case "decision": {
        Z(
          `vca.${r.type}.${r.response.responseCode}`,
          {
            "app.session": e.flowSessionId,
            "app.group": t.group,
            "event.provider": r.response.providerId,
            "event.provider.key": r.response.providerKey,
            "event.application": r.response.versatileApplicationId,
            "event.approved-amount-cents": r.response.approvedAmountCents ?? 0,
            "event.apr": r.response.apr
          }
        );
        break;
      }
      case "page-view": {
        Z(`vca.${r.type}`, {
          "app.session": e.flowSessionId,
          "app.group": t.group,
          "event.from": r.fromUrl,
          "event.to": r.toUrl
        });
        break;
      }
      case "end": {
        Z(`vca.${r.type}`, {
          "app.session": e.flowSessionId,
          "app.group": t.group,
          "event.flow": r.flow,
          "event.outcome": r.outcome
        });
        const n = bt();
        n.content = "";
        break;
      }
    }
  };
}, Po = () => {
  const e = Lr(), t = [
    go(),
    yo(),
    ho()
  ];
  if (ze() && t.push(fo(window.opener ?? window.parent)), e.mode === "development") {
    const r = R("LoggingEventPublisher");
    t.push(mo(r));
  }
  return t;
}, ee = () => {
  const e = Po();
  return (t) => e.forEach((r) => r(t));
}, wo = (e) => {
  const t = v(), r = w();
  return async (n) => {
    const i = n.getResponseToContinueWith();
    if (i && i.provider)
      t.switchProvider(i.provider.providerKey), r.switchApplyMode(i.applyMode), await x(), await e.presentMultipleOffers(n);
    else
      throw new Error("Unhandled Cascade response!");
  };
}, Ao = (e) => {
  const t = Je();
  return async (r) => {
    const n = r.nextProvider(), i = r.nextApplyMode();
    if (n && i)
      if (await t({
        providerKey: n,
        applyMode: i
      }), await x(), r.isResumingNextProvider()) {
        const o = r.getResponseForProvider(n);
        if (!o)
          throw new Error(
            "Response was not returned for the provider " + n
          );
        await e.presentDecision(
          new ke(n),
          o,
          r
        );
      } else
        await e.transitionTo(
          new ke(n),
          i,
          r
        );
    else
      throw new Error("Unhandled Cascade response!");
  };
}, Sr = (e) => {
  const t = v(), r = w();
  return async (n) => {
    const i = n.getResponseToContinueWith();
    if (i && i.provider) {
      const { providerKey: o } = i.provider;
      t.switchProvider(o), r.switchApplyMode(i.applyMode);
      const s = t.findProviderConfig(o);
      s && (i.provider.productType && (s.productType = i.provider.productType), i.provider.providerBankId && (s.providerBankId = i.provider.providerBankId)), await x(), await e.presentDecision(
        new ke(o),
        i,
        n
      );
    } else
      throw new Error("Unhandled Cascade response!");
  };
}, So = (e) => Sr(e), Ro = () => {
  const e = O();
  return h(() => e.extensions.find(
    (r) => r.featureId === "hosted-flow"
  )?.properties);
}, Et = "vst.app_session", bo = () => {
  const e = Ro(), t = O(), r = (s, a) => new Date(s.getTime() + a * 1e3);
  return {
    enabled: h(() => e.value !== null),
    clearSession: () => {
      ut.remove(Et);
    },
    persistSession: () => {
      e.value && t.flowSessionId && ut.set(Et, t.flowSessionId, {
        domain: e.value.cookieDomain,
        secure: !0,
        sameSite: "lax",
        expires: r(/* @__PURE__ */ new Date(), e.value.cookieDuration)
      });
    }
  };
}, Ja = (e) => Eo(e, Ce.ACCEPT_OFFER), Eo = (e, t) => {
  const r = h(
    () => f(t) === Ce.ACCEPT_OFFER
  ), n = R(
    () => r.value ? "use-accept-offer.ts" : "use-submit-application.ts"
  ), i = O(), o = Qe(), s = Sr(e), a = So(e), c = Ao(e), l = wo(e), d = ee(), p = bo(), C = (P) => {
    const b = i.flowSessionId;
    b && d({
      type: "decision",
      response: P,
      sessionId: b
    });
  };
  Yt(async () => {
    await x();
    let P;
    return r.value ? (n.info("Accepting Offer"), P = await o.acceptOffer()) : (n.info("Submitting Application"), P = await o.submitApplication()), P.allResponses.map((I) => I.provider).filter((I) => I != null).forEach(C), p.enabled.value && p.persistSession(), P.hasSingleOffer() ? (n.info("Handling Single Offer"), await a(P)) : P.hasMultipleOffers() ? (n.info("Handling Multiple Offers"), await l(P)) : f(e.canSwitchProviders ?? !0) && P.shouldSwitchProviders() ? (n.info("Handling Provider Transition"), await c(P)) : (n.info("Handling Standard Response"), await s(P));
  });
};
var Dt, Ft, Nt, xt, ae;
class le extends (xt = H, Nt = [L("Submit Application")], Ft = [L("Patch Application")], Dt = [L("Accept Offer")], xt) {
  constructor(r, n, i) {
    super(n);
    he(ae, 5, this);
    z(this, "client");
    z(this, "logger");
    this.client = r, this.logger = i;
  }
  async submitApplication(r) {
    const n = new ye(this.provider, this.applyMode);
    switch (n.mode) {
      case "prescreen":
        await this.prescreen(n, r);
        break;
      case "prequalify":
        await this.prequalify(n, r);
        break;
      default:
        await this.apply(n, r);
    }
    return new ve(n);
  }
  async patchApplication() {
    const r = this.buildCreditApp();
    if (!r)
      throw new Error("Invalid application state");
    const n = {
      application: r
    }, i = await this.client.patch(this.provider, n);
    return i.provider && v().setPreauthResponse(i.provider), i;
  }
  async acceptOffer() {
    const r = new ye(this.provider, this.applyMode);
    if (!this.buildCreditApp())
      throw new Error("Invalid application state");
    const i = async (o, s) => {
      let a = this.providerModule.asyncOfferAcceptance ? await this.client.submitApplication(this.provider, s) : await this.client.acceptOffer(this.provider, s);
      return a.provider?.responseCode === u.SUBMITTED && (a = await this.waitForOfferAcceptance(
        (/* @__PURE__ */ new Date()).getTime() + 6e4
      )), a.provider && (a.provider.operation = Ce.ACCEPT_OFFER), a;
    };
    return await this.execute(r, {}, i), new ve(r);
  }
  async addBankCard(r) {
    return await this.client.addBankCard(this.provider, r);
  }
  async addBankAccount(r) {
    return await this.client.addBankAccount(this.provider, r);
  }
  async initiateExternalApplication(r, n) {
    const i = await this.client.launchExternalApplication(
      r,
      n
    );
    if (!i.url)
      throw new Error("No redirect url received");
    const o = _(), s = o.flowSessionId;
    if (!s)
      throw new Error(
        "Unable to launch external application id without a sessionId"
      );
    await o.persistStoreToSession(s), this.logger.info(
      `Redirecting to external application URL - ${i.url}`
    ), window.location.href = i.url;
  }
  async addExternalResponse(r) {
    const n = new ye(
      this.provider,
      r.applyMode
    );
    return await this.execute(n, {}, async () => r), new ve(n);
  }
  async waitForOfferAcceptance(r) {
    this.logger.info("Checking status of offer acceptance:", this.provider);
    const n = await this.client.checkApplication(this.provider);
    if (!n.provider)
      throw new Error("Provider is missing from response");
    switch (n.provider.responseCode) {
      case u.SUBMITTED:
        if (r > (/* @__PURE__ */ new Date()).getTime())
          return se(5e3, () => this.waitForOfferAcceptance(r));
        break;
      case u.APPROVED:
        if (this.providerModule.requiresAccountCreation)
          return this.client.createAccount(this.provider);
        break;
    }
    return n;
  }
  async waitForApplicationStatus(r) {
    this.logger.info("Checking status of application status:", this.provider);
    const n = await this.client.checkApplication(this.provider);
    if (!n.provider)
      throw new Error("Provider is missing from response");
    return r > (/* @__PURE__ */ new Date()).getTime() && n.provider.responseCode === u.SUBMITTED ? se(5e3, () => this.waitForApplicationStatus(r)) : n;
  }
  async waitForPrequalifyStatus(r, n) {
    this.logger.info(
      "Checking status of prequalify application status:",
      r.provider
    ), U(r.provider).asyncPrequalifySubmissionRequiresRefresh && await this.client.refreshPrequalifyApplication(r.provider);
    const i = await this.client.checkPrequalifyApplication(
      r.provider
    );
    if (!i.provider)
      throw new Error("Provider is missing from response");
    return n > (/* @__PURE__ */ new Date()).getTime() && i.provider.responseCode === u.SUBMITTED ? se(
      5e3,
      () => this.waitForPrequalifyStatus(r, n)
    ) : i;
  }
  async getIframeUrl() {
    return this.client.geIframeUrl(this.provider);
  }
  async getEsignIframeUrl(r) {
    return this.client.getEsignIframeUrl(this.provider, r);
  }
  async getEsignIframeUrlWithRedirect(r) {
    return this.client.getEsignIframeUrlWithRedirect(this.provider, r);
  }
  esignApplication(r = {}) {
    return this.providerKey === "aqua_standard" ? this.esignAquaApplication(r) : this.client.esign(this.provider, r);
  }
  // This is to workaround Aqua having a deadlock in their database.
  // Instead of them fixing their backend issues, they advised us to wait
  // and retry this.
  async esignAquaApplication(r) {
    let n = await this.client.esign(this.provider, r);
    if (n.responseCode === "error") {
      let i = 5;
      for (; i > 0 && n.responseCode === "error"; )
        this.logger.warn(
          `Retrying esign generation, previous attempt resulted in error, attempts remaining=${i}`
        ), n = await se(
          3e4,
          () => this.client.esign(this.provider, r)
        ), i--;
    }
    return n.responseCode === "error" && this.logger.error(
      "Failed to esign application after repeated attempts with the lender"
    ), n;
  }
  async getEsignStatus() {
    return this.client.getEsignStatus(this.provider);
  }
  async getEsignStatuses() {
    return this.client.getEsignStatuses(this.provider);
  }
  async completeApplication() {
    return this.client.completeApplication(this.provider);
  }
  async paymentToken(r) {
    const n = w(), i = await this.client.paymentToken(this.provider, r);
    return (i.paymentToken || i.paymentType == "cash") && n.addPayment(i), i;
  }
  async hydrateProvider(r) {
    const n = w(), i = de(this.provider), o = v();
    if (this.isApproved(r.responseCode)) {
      const s = U(r.providerKey), { loadPaymentPlans: a, loadPurchaseDetails: c } = s.hydrationPostProcessing;
      if (a && this.shouldFetchPlans(r)) {
        const l = r.approvedAmountCents ?? 0, d = i.value ?? 0, p = Ee(
          l,
          d,
          n.application?.downPaymentAmountCents
        ), C = await this.client.getPaymentPlans(
          r.providerKey,
          d,
          p
        );
        o.setPaymentPlans(r.providerKey, C);
      }
      if (c) {
        const l = await this.client.getPurchaseDetails(
          r.providerKey
        );
        o.setPurchaseDetails(r.providerKey, l);
      }
    }
  }
  async continueCascade(r, n) {
    const i = new ye(this.provider, this.applyMode);
    return i.appendResponse(r), await this.handleResponse(i, n), new ve(i);
  }
  async prequalify(r, n) {
    const i = U(r.provider);
    i.asyncPrequalifySubmission ? await this.execute(r, n, async (o, s) => {
      const a = await this.client.prequalify(o, s);
      return a?.provider?.responseCode === u.SUBMITTED ? this.doAfterAsyncPrequalify(a.provider.providerKey) : a;
    }) : i.submitAfterPrequalify ? await this.execute(r, n, async (o, s) => {
      const a = await this.client.prequalify(o, s);
      return a?.provider?.responseCode === u.SUBMITTED ? await this.client.submitAfterPrequalify(o) : a;
    }) : await this.execute(
      r,
      n,
      this.client.prequalify.bind(this.client)
    );
  }
  async doAfterAsyncPrequalify(r) {
    const n = U(r), i = await this.pollForPrequalifyStatus(
      n,
      r,
      (/* @__PURE__ */ new Date()).getTime() + 9e4
    );
    return i.provider?.responseCode === u.PREQUALIFIED && n.refreshApplicationAfterPrequalified ? await this.client.checkApplication(r) : i;
  }
  async pollForPrequalifyStatus(r, n, i) {
    this.logger.info(
      "Checking status of prequalify application status:",
      n
    ), r.asyncPrequalifySubmissionRequiresRefresh && await this.client.refreshPrequalifyApplication(n);
    const o = await this.client.checkPrequalifyApplication(n);
    if (!o.provider)
      throw new Error("Provider is missing from response");
    return i > (/* @__PURE__ */ new Date()).getTime() && o.provider.responseCode === u.SUBMITTED ? se(
      5e3,
      () => this.pollForPrequalifyStatus(r, n, i)
    ) : (o.provider.responseCode === u.SUBMITTED && (o.provider.responseCode = u.PENDING), o);
  }
  async handlePendingPrequalResume(r) {
    const n = r.providerKey, i = U(n);
    let o;
    if (i.asyncPrequalifySubmission ? o = await this.doAfterAsyncPrequalify(n) : i.submitAfterPrequalify && r?.responseCode === u.SUBMITTED ? o = await this.client.submitAfterPrequalify(n) : o = await this.client.checkPrequalifyApplication(n), !o.provider)
      throw new Error("Provider is missing from response");
    return v().setPreauthResponse(o.provider), o;
  }
  async rollbackLoan() {
    return this.client.rollbackLoan(this.provider);
  }
  async getDomainCategories(r) {
    return this.client.getDomainCategories(r);
  }
  async prescreen(r, n) {
    await this.execute(
      r,
      n,
      this.client.prescreen.bind(this.client)
    );
  }
  async apply(r, n) {
    this.providerModule.asyncApplicationSubmission ? await this.execute(r, n, async (i, o) => {
      const s = await this.client.submitApplication(
        i,
        o
      );
      return s?.provider?.responseCode === u.SUBMITTED ? this.waitForApplicationStatus(Date.now() + 4e4) : s;
    }) : await this.execute(r, n, this.client.apply.bind(this.client));
  }
  async execute(r, n = {}, i) {
    const o = this.buildCreditApp();
    if (!o)
      throw new Error("Invalid application state");
    const s = n.providerConfig ? n.providerConfig(r.provider) : void 0;
    this.addDeviceInfo(o), this.calculateIncome(o), this.setInstallationLocation(o);
    const a = v(), c = {
      application: o,
      autoSubmit: r.autoSubmit,
      returnUrl: s?.returnUrl,
      trustSessionId: a.findTrustSessionId(r.provider)
    };
    try {
      await r.execute((l) => i(l, c)), await this.handleResponse(r, n);
    } catch (l) {
      await this.handleError(r, l);
    }
  }
  async handleResponse(r, n) {
    const i = r.lastResponse;
    if (await this.storeResponse(r.provider, i), !i.provider) {
      const o = new Error("Unknown response, provider is missing");
      throw B(o), o;
    }
    if (i.provider?.responseCode === u.ERROR) {
      const o = i.provider;
      Qi(
        "provider_application_error",
        `${o.providerKey} ${o.operation} resulted in error`,
        `versatile application id: ${o.versatileApplicationId}`
      );
    }
    if (i.provider.responseCode === u.PREAPPROVED || i.provider.responseCode === u.PREQUALIFIED) {
      const o = w();
      o.applyStage = "offer";
    }
    i.next && await this.cascade(r, n);
  }
  async handleError(r, n) {
    if (B(n), n instanceof jt)
      if (this.logger.error(
        `${r.provider} application contains validation errors`
      ), r.hasLastResponse()) {
        const i = r.lastResponse.next;
        if (i) {
          this.logger.info(`Forwarding cascade to start at ${r.provider}`), r.start = !0, i.validationError = n.error, i.autoSubmit = !1;
          return;
        }
      } else
        this.logger.warn(
          `Initial submission contained validation errors ${r.provider}, can't handle this here!`
        );
    throw this.logger.error(
      `FATAL: ${r.provider} application failed while submitting re-throwing`,
      n
    ), n;
  }
  async cascade(r, n) {
    if (!r.lastResponse.next)
      return;
    const i = r.lastResponse.next;
    if (i.resultType !== "provider") {
      this.logger.warn("Unknown resultType from Cascade", i.resultType);
      return;
    }
    if (r.autoSubmit = i.autoSubmit, !i.requireUserAction) {
      if (!i.autoSubmit) {
        r.start = !i.resume, r.resume = i.resume;
        return;
      }
      if (!i.topoff)
        switch (r.provider = i.provider.providerKey, r.mode = i.applyMode, i.applyMode) {
          case "prescreen":
            await this.prescreen(r, n);
            break;
          case "prequalify":
            await this.prequalify(r, n);
            break;
          default:
            await this.apply(r, n);
        }
    }
  }
  calculateIncome(r) {
    const n = r.primary?.income;
    n && this.normalizeIncome(n);
    const i = r.joint?.income;
    i && this.normalizeIncome(i);
  }
  addDeviceInfo(r) {
    if (r.device?.type != null)
      return;
    const n = di().type, i = r.device;
    i == null ? r.device = {
      type: n
    } : i.type = n;
  }
  setInstallationLocation(r) {
    if (r.installationAddressSameAsPrimary) {
      const n = r.installationLocation;
      n && (n.address = r.primary?.homeAddress);
    }
  }
  normalizeIncome(r) {
    const n = r.grossAnnualCents, i = r.grossMonthlyCents;
    n != null && Rt(i) && (r.grossMonthlyCents = n / 12), i != null && Rt(n) && (r.grossAnnualCents = i * 12);
  }
  async storeResponse(r, n) {
    const i = w(), o = de(r);
    if (i.addResponse(n), n.provider) {
      const s = v();
      if (n.applyMode === "full" ? s.setApplyResponse(n.provider) : s.setPreauthResponse(n.provider), i.stipulations = n.session?.stipulations ?? [], this.shouldFetchPlans(n.provider)) {
        const a = n.provider.approvedAmountCents ?? 0, c = o.value ?? a, l = Ee(
          a,
          c,
          i.application?.downPaymentAmountCents
        ), d = await this.client.getPaymentPlans(
          r,
          c,
          l
        );
        s.setPaymentPlans(r, d);
      }
    }
  }
  isApproved(r) {
    return [
      u.PREQUALIFIED,
      u.PREAPPROVED,
      u.APPROVED
    ].includes(r);
  }
  shouldFetchPlans(r) {
    const n = U(r.providerId);
    return n.fetchPaymentPlansOnPreauthApproval && this.isPreApproved(r.responseCode) ? !0 : this.isApproved(r.responseCode) && n.fetchPaymentPlansOnApproval;
  }
  buildCreditApp() {
    const r = w();
    if (!r.application)
      return;
    const n = de(this.provider);
    return {
      ...r.application,
      purchaseAmountCents: n.value
    };
  }
  isPreApproved(r) {
    return [
      u.PREQUALIFIED,
      u.PREAPPROVED
    ].includes(r);
  }
}
ae = me(xt), D(ae, 1, "submitApplication", Nt, le), D(ae, 1, "patchApplication", Ft, le), D(ae, 1, "acceptOffer", Dt, le), ie(ae, le);
var Lt, Ut, Kt, Bt, kt, qt, Gt, $;
class V extends (Gt = H, qt = [L("Start Flow - Token")], kt = [L("Start Flow - Entity Key")], Bt = [L("Start Flow - Default")], Kt = [L("Restart Flow")], Ut = [L("Restore Flow")], Lt = [L("Reevaluate Cascade")], Gt) {
  constructor(r, n, i, o) {
    super(n);
    he($, 5, this);
    z(this, "client");
    z(this, "applicationService");
    z(this, "startProvider");
    this.client = r, this.applicationService = i, this.startProvider = o;
  }
  async startFlowWithToken(r, n) {
    return this.startFlow(() => this.client.startFlowWithToken(r), n);
  }
  async startFlowWithEntityKey(r, n = {}, i) {
    return this.startFlow(
      () => this.client.startFlowWithEntityKey(r, n),
      i
    );
  }
  async startFlowWithDefaultEntityKey(r) {
    return this.startFlow(
      () => this.client.startFlowWithDefaultEntityKey(),
      r
    );
  }
  async restartFlow(r) {
    const n = await this.client.restartFlow(), i = v();
    return n.providerConfigs.forEach((o) => {
      i.resetProvider(o.providerKey);
    }), this.startFlowWithResponse(n, r);
  }
  async restoreFlow(r, n) {
    return this.startFlowWithResponse(
      await this.client.restoreFlow(n),
      r
    );
  }
  async reevaluateCascade(r, n) {
    const i = await this.client.reevaluateCascade(r);
    return this.startFlowWithResponse(i, n);
  }
  async startFlow(r, n) {
    return this.store.resetAll(), this.startFlowWithResponse(await r(), n);
  }
  async startFlowWithResponse(r, n) {
    const i = X();
    switch (i.identify(r.flowSessionId), i.addStringActionProperty("flow-type", r.flowType), W().doInitialize(r), Ye().doInitialize(r), O().doInitialize(r), r.flowType) {
      case "apply":
        return this.startApplyFlow(r, n);
      case "credit_limit_change":
        return this.startCreditLimitChangeFlow(r);
      case "pre_apply":
        return this.startPreApplyFlow(r);
      case "oh_my_bobs":
        return this.startBdfAssociateFlow(r);
      default:
        throw new Error(`Unsupported flow type: ${r.flowType}`);
    }
  }
  async startApplyFlow(r, n) {
    const i = w();
    if (i.application = structuredClone(r.application), i.originalApplication ??= structuredClone(
      r.application
    ), i.stipulations = r.sessionStipulations ?? [], !r.start.providers.length)
      throw new Error("Invalid Configuration - No providers are available.");
    const o = v();
    o.initializeCascade(r.start.providers), r.providerStates.length && r.providerStates.forEach(
      (d) => this.setupProviderState(r, d)
    ), i.primaryProviderApplyMode = r.start.applyMode, o.primary = r.start.providers[0];
    const s = this.startProvider(r.start);
    let a = !!r.resume, c = s.providerKey;
    const l = r.resume && "cascadeResponse" in r.resume ? r.resume.cascadeResponse : void 0;
    if (l) {
      i.addResponse({
        ...l,
        applyMode: r.start.applyMode
      });
      const d = await this.applicationService.continueCascade(
        l,
        n?.submitApp
      );
      a = !0, c = d.getResponseToContinueWith()?.provider?.providerKey ?? s.providerKey, this.resetStateAfterResume(o, c, r);
    }
    return {
      experienceType: r.experienceType,
      flowType: r.flowType,
      providerKey: c,
      resume: a
    };
  }
  startPreApplyFlow(r) {
    j().setFields(r.fields);
    const i = w();
    return i.originalApplication = structuredClone(r.application), {
      experienceType: r.experienceType,
      flowType: r.flowType,
      resume: !1
    };
  }
  startBdfAssociateFlow(r) {
    const n = w();
    return n.originalApplication = structuredClone(r.application), v().initializeCascade(r.providerConfigs), r.providerStates.length && r.providerStates.forEach(
      (o) => this.setupProviderState(r, o)
    ), {
      experienceType: r.experienceType,
      flowType: r.flowType,
      resume: !1
    };
  }
  startCreditLimitChangeFlow(r) {
    throw new Error("startCreditLimitChangeFlow not implemented.");
  }
  setupProviderState(r, n) {
    if (this.shouldIgnoreProviderState(r, n))
      return;
    v().initializeProvider(n);
  }
  resetStateAfterResume(r, n, i) {
    const o = i.providerStates.find(
      (s) => s.providerKey === n
    );
    o && this.shouldIgnoreProviderState(i, o) && r.resetProvider(n);
  }
  shouldIgnoreProviderState(r, n) {
    return !r.properties.resetToOffers || !n.applyResponse ? !1 : [
      u.PENDING,
      u.APPROVED,
      u.NOOFFER,
      u.DECLINED,
      u.SUBMITTED
    ].includes(n.applyResponse.responseCode);
  }
}
$ = me(Gt), D($, 1, "startFlowWithToken", qt, V), D($, 1, "startFlowWithEntityKey", kt, V), D($, 1, "startFlowWithDefaultEntityKey", Bt, V), D($, 1, "restartFlow", Kt, V), D($, 1, "restoreFlow", Ut, V), D($, 1, "reevaluateCascade", Lt, V), ie($, V);
class Co {
  client;
  constructor(t) {
    this.client = t;
  }
  async validateZipCode(t, r) {
    return (await this.client.validateZipCode({ state: t, zipCode: r })).valid;
  }
  async validatePhone(t) {
    return (await this.client.validatePhone({ phoneNumber: t })).valid;
  }
  async validateApplication(t, r) {
    const n = w();
    try {
      return await this.client.validateApplication({
        providerKeys: t,
        applicationData: n.application ?? {},
        fieldIds: r
      }), null;
    } catch (i) {
      if (i instanceof jt)
        return i.error;
      throw i;
    }
  }
}
var $t, Vt, Wt, Ae;
class Re extends (Wt = H, Vt = [L("Select Payment Plans")], $t = [L("Select Payment Plan")], Wt) {
  constructor(r, n) {
    super(n);
    he(Ae, 5, this);
    z(this, "client");
    this.client = r;
  }
  getPaymentPlans(r, n, i) {
    const o = X();
    return o.addStringActionProperty("providerKey", r), o.addNumberActionProperty("purchaseAmountCents", n), o.addNumberActionProperty(
      "downPaymentAmountCents",
      i ?? 0
    ), this.client.getPaymentPlans(
      r,
      n,
      i
    );
  }
  async selectPaymentPlan(r) {
    const n = this.store.applyMode;
    if (!n)
      throw new Error("Invalid application state. ApplyMode is not set!");
    const i = w(), s = v().findResponseByMode(
      r.providerKey,
      n
    );
    if (!s)
      throw new Error(
        `Unable to locate provider response for ${r.providerKey} and ${n}`
      );
    const a = i.application?.purchaseAmountCents, c = Ee(
      r.approvedAmountCents ?? s.approvedAmountCents ?? 0,
      a ?? 0,
      i.application?.downPaymentAmountCents
    ), l = X();
    l.addStringActionProperty("providerKey", r.providerKey), l.addStringActionProperty("providerPlanCode", r.providerPlanCode), l.addNumberActionProperty("financeAmountCents", a ?? 0), l.addNumberActionProperty(
      "downPaymentAmountCents",
      c ?? 0
    ), r.providerPlanId && l.addStringActionProperty("providerPlanId", r.providerPlanId);
    const d = {
      providerPlanCode: r.providerPlanCode,
      financeAmountCents: a,
      downPaymentAmountCents: c,
      offerId: r.providerPlanId,
      promotionalName: r.promotionalName
    };
    await this.client.selectPaymentPlan(r.providerKey, d), i.selectedPlan = r;
    const p = {
      providerKey: r.providerKey,
      paymentPlanCode: r.providerPlanCode
    };
    i.setApplicationValue("selectedOffer", p), i.setApplicationValue(
      "downPaymentAmountCents",
      c
    );
  }
  publishPlansPresented(r, n) {
    return this.client.publishPlansPresented({
      providerKeys: r,
      isSummary: n
    });
  }
  publishFinancingOptionSummaryPresented(r) {
    return this.client.publishFinancingOptionSummaryPresented(
      r
    );
  }
}
Ae = me(Wt), D(Ae, 1, "getPaymentPlans", Vt, Re), D(Ae, 1, "selectPaymentPlan", $t, Re), ie(Ae, Re);
class Io extends H {
  client;
  constructor(t, r) {
    super(r), this.client = t;
  }
  async refreshProviderStipulations(t) {
    const { stipulations: r } = await this.client.refreshStipulations(t);
    v().setStipulations(t, r);
  }
  async refreshSessionStipulationStatus(t) {
    const { status: r } = await this.client.getStipulationStatus(t.id);
    w().updateStipulation({
      ...t,
      status: r
    });
  }
  async uploadStipulationDocument(t, r, n) {
    const i = {
      stipulationId: r.id,
      document: n
    };
    return this.client.uploadStipulationDocument(t, i);
  }
}
class Mo extends H {
  client;
  constructor(t, r) {
    super(r), this.client = t;
  }
  getApplyTermsUrl(t, r) {
    const n = this.provider, i = this.providerKey, o = this.client.baseUrl ?? "", s = this.client.sessionId ?? "", a = r ?? this.store.applyMode, c = {
      contentType: t,
      sid: s
    };
    switch (i) {
      case "fortiva_standard": {
        const d = v().findApplyResponse(i);
        return Pe(
          `${o}/api/v1/providers/${n}/documents/${r ?? (d ? "agreement" : "credit_terms")}`,
          c
        ).toString();
      }
      case "hfd_standard":
        return Pe(
          `${o}/api/v1/providers/${encodeURIComponent(n)}/application/terms/esignDoc`,
          c
        ).toString();
      default:
        return Pe(
          `${o}/api/v1/providers/${n}/application/terms/${a}`,
          c
        ).toString();
    }
  }
  async getDisclosures(t, r) {
    return await this.client.getDisclosures(t, r);
  }
  getDisclosuresUrl(t) {
    const r = this.client.baseUrl ?? "", n = this.client.sessionId ?? "", i = t ?? this.provider, o = t ? N(t) : this.providerKey, s = {
      sid: n
    };
    return o === "fortiva_standard" ? (s.convertToImage = "false", Pe(
      `${r}/api/v1/providers/${i}/documents/electronic_consent`,
      s
    ).toString()) : null;
  }
  getTermsHtml() {
    return this.client.getTermsHtml(this.provider);
  }
  getAgreementHtml() {
    return this.client.getAgreementHtml(this.provider);
  }
}
class Oo extends H {
  client;
  constructor(t, r) {
    super(r), this.client = t;
  }
  async switchTestCase(t) {
    const r = await this.client.loadTestCase(t);
    if (r) {
      const n = w();
      n.applyMode = r.applyMode, n.applyStage = r.applyMode, n.application = { ...r.application }, n.originalApplication = {
        ...r.application
      }, r.fields.length && j().setFields(r.fields), r.providers.length && v().initializeCascade(r.providers);
    }
  }
}
const Fe = {
  AccountServiceKey: /* @__PURE__ */ Symbol("accountService"),
  VerificationServiceKey: /* @__PURE__ */ Symbol(
    "verificationService"
  ),
  GoogleTagManagerKey: /* @__PURE__ */ Symbol(
    "google-tag-manager"
  ),
  OmniApplyClientKey: jr
}, To = {
  install: (e, t) => {
    const r = _(), n = O();
    e.use(Hr, {
      baseUrl: t.api.omniApply.baseUrl,
      onSessionTimeout: () => n.doTimeout(),
      requestIdProvider: () => yr(),
      sessionProvider: () => n.sessionId
    });
    const i = zr(e);
    e.provide(
      Fe.AccountServiceKey,
      new Gi(i, r)
    ), e.provide(
      Fe.VerificationServiceKey,
      new vr(i, r)
    ), e.provide(Fe.GoogleTagManagerKey, new K());
  }
}, _o = (e) => {
  if (typeof e == "string")
    return {
      name: e.startsWith("/") ? void 0 : e,
      path: e.startsWith("/") ? e : void 0
    };
  const { to: t, params: r, ...n } = e;
  return t.startsWith("/") ? {
    path: t,
    ...n
  } : {
    name: t,
    params: r,
    ...n
  };
};
class Do {
  router;
  loader;
  constructor(t, r) {
    this.router = t, this.loader = r;
  }
  listen() {
    const t = W();
    G(
      () => t.group,
      (r) => this.loadGroupRoutes(r)
    ), t.group && this.loadGroupRoutes(t.group);
  }
  loadGroupRoutes(t) {
    sn(`routes-${t}`, async () => {
      const r = await this.loader(t);
      r?.length && this.importRoutes(t, r);
    });
  }
  importRoutes(t, r) {
    r.forEach((n) => this.importRoute(t, n));
  }
  importRoute(t, r, n = !0) {
    const i = r.name;
    r.meta = {
      ...r.meta || {},
      group: t
    }, i && (r.name = `${i.toString()}.${t}`);
    const o = r.meta.appendTo;
    o ? this.router.addRoute(o, r) : n && this.router.addRoute(r), r.children?.forEach((s) => this.importRoute(t, s, !1));
  }
}
const Rr = () => (e) => {
  const t = Nr();
  if (e.name === t.error)
    return !0;
  const r = O();
  if (r.needsRestore && e.meta.restore === !0 || r.isActive || e.meta.public === !0)
    return !0;
  const n = Ve();
  let i = t.unauthorized;
  return n.error && (i = t.error), r.timedout && (i = t.session_timeout), r.needsRestore && (i = t.session_restore), i.startsWith("/") ? {
    path: i,
    replace: !0
  } : {
    name: i,
    replace: !0
  };
}, Fo = () => (e, t) => {
  t.meta.cleanup && t.name && We().removeRoute(t.name);
}, br = () => async (e) => {
  const t = Nr();
  if (e.name === t.error)
    return !0;
  const r = new URLSearchParams(window.location.search), n = r.get("go"), i = r.get("returnId");
  if (!n)
    return !0;
  const o = _();
  i && await o.reloadStoreFromSession(i), o.clearedStoredAppStates(), r.delete("go"), r.delete("returnId");
  const s = new URL(window.location.href), a = {};
  for (const [c, l] of r.entries())
    a[c] = l, r.delete(c);
  return await x(), s.search = "", window.history.replaceState(null, "unused", s.toString()), {
    path: n,
    query: a,
    replace: !0
  };
}, Er = () => (e, t) => {
  const r = ee();
  setTimeout(() => {
    r({
      type: "page-view",
      toUrl: e.fullPath,
      fromUrl: t.fullPath
    });
  }, 0), K.getInstance().push({
    event: "vue.RouteChange",
    current_page_name: e.name?.toString()?.replace(/-/g, " ")?.replace(/\./g, " ")?.replace(/\b\w/g, (n) => n.toUpperCase()),
    current_page_url: e.fullPath,
    previous_page_url: t.fullPath
  });
}, No = (e, t) => e.path === t, xo = (e, t) => e.meta?.extends === t, Cr = (e, t) => {
  const r = e.meta || {}, n = !r.groupId || r.groupId === t.group, i = !r.applyMode || r.applyMode === t.mode, o = !r.providerKey || r.providerKey === t.providerKey;
  return n && i && o;
}, Ir = (e, t) => Ue(t.meta || {}).length - Ue(e.meta || {}).length, Ct = (e) => {
  const t = e.matched.length;
  return t ? e.matched[t - 1]?.path ?? e.path : e.path;
}, Mr = (e, t) => e.redirectedFrom ? e.redirectedFrom.name === t.name || Mr(e.redirectedFrom, t) : e.meta.extends === t.name, Lo = (e) => {
  const t = (n, i, o) => {
    if (n.meta.extends) {
      const a = e.router.getRoutes().find((c) => c.name === n.meta.extends);
      if (a) {
        const c = Ct(i);
        return a.path === c && o.path !== c;
      }
    }
    const s = Ct(i);
    return n.path === s && o.path !== s;
  }, r = (n) => n.params.finalized === "true";
  return (n, i) => {
    const o = e.router.computeGlobalRouteParams();
    if (r(n))
      return;
    const s = e.router.getRoutes().filter((a) => t(a, n, i)).filter((a) => Cr(a, o)).sort(Ir);
    if (s.length) {
      const a = s[0];
      return a == null || Mr(n, a) || n.name === a.name ? void 0 : {
        name: a.name,
        params: {
          ...o,
          resolvedBy: a?.name?.toString(),
          finalized: "true"
        }
      };
    }
  };
};
class Uo {
  router;
  listeners = [];
  store;
  routeByName = {};
  constructor(t, r) {
    this.router = this.buildRouter(t), this.store = r, this.router.addRoute({
      name: "__internal.error",
      path: "/internal/error",
      redirect: t.generalRouteMappings.error
    });
    const n = {
      routerSettings: t,
      router: this
    };
    this.beforeEach(Xt()), this.beforeEach(br()), this.beforeEach(Rr()), t.useLocalizedRouteGuard && this.beforeEach(Lo(n)), t.beforeResolve?.length && t.beforeResolve.forEach((i) => {
      this.beforeResolve(i(r));
    }), this.afterEach(Er()), this.afterEach(er()), this.listeners.push(
      new Do(this, t.groupRouteLoader)
    );
  }
  buildRouter(t) {
    const { routes: r, ...n } = t;
    this.populateRoutes(r);
    const i = this.mergeRoutes(r);
    return rr({
      routes: i,
      ...n
    });
  }
  install(t) {
    this.router.install(t), t.config.globalProperties.$router = this, t.provide(vn, this), this.listeners.forEach((r) => r.listen());
  }
  get listening() {
    return this.router.listening;
  }
  get currentRoute() {
    return this.router.currentRoute;
  }
  get options() {
    return this.router.options;
  }
  addRoute(t, r) {
    if (typeof t == "string" && r)
      return this.populateRoute(r), this.router.addRoute(t, this.mergeRoute(r));
    const n = t;
    return this.populateRoute(n), this.router.addRoute(this.mergeRoute(n));
  }
  afterEach(t) {
    return this.router.afterEach(t);
  }
  back() {
    return this.router.back();
  }
  beforeEach(t) {
    return this.router.beforeEach(t);
  }
  beforeResolve(t) {
    return this.router.beforeResolve(t);
  }
  forward() {
    return this.router.forward();
  }
  findRouteByName(t) {
    return this.routeByName[t];
  }
  getRoutes() {
    return this.router.getRoutes();
  }
  go(t) {
    this.router.go(t);
  }
  hasRoute(t) {
    return this.router.hasRoute(t);
  }
  isReady() {
    return this.router.isReady();
  }
  push(t) {
    return this.router.push(this.computeRouteLocation(t));
  }
  removeRoute(t) {
    delete this.routeByName[t], this.router.removeRoute(t);
  }
  replace(t) {
    return this.router.replace(this.computeRouteLocation(t));
  }
  resolve(t, r) {
    return this.router.resolve(t, r);
  }
  onError(t) {
    return this.router.onError(t);
  }
  clearRoutes() {
    this.router.clearRoutes();
  }
  computeRouteLocation(t) {
    return typeof t == "string" ? this.computeRouteLocation({
      name: t.startsWith("/") ? void 0 : t,
      path: t.startsWith("/") ? t : void 0
    }) : "name" in t && t.name ? this.resolveByRouteName(t) : "path" in t && t.path ? this.resolveByRoutePath(t) : t;
  }
  resolveByRoutePath(t) {
    const n = gn(
      this.router.getRoutes(),
      this.router.options
    ).resolve(
      { path: t.path },
      Qr(this.router.currentRoute)
    );
    if (n?.name)
      return this.resolveByRouteName({
        name: n.name,
        params: n.params,
        query: t.query
      });
    if (n?.matched.length) {
      const i = n.matched[n.matched.length - 1];
      if (i?.name)
        return this.resolveByRouteName({
          name: i.name,
          params: n.params,
          query: t.query
        });
    }
    return t;
  }
  resolveByRouteName(t) {
    const r = this.router.getRoutes().find((o) => o.name === t.name);
    if (!r)
      return t;
    const n = {
      ...this.computeGlobalRouteParams(),
      ...t.params
    }, i = this.router.getRoutes().filter(
      (o) => No(o, r.path) || xo(o, r.name)
    ).filter((o) => Cr(o, n)).sort(Ir);
    return i.length ? {
      name: i[0]?.name ?? r.name,
      hash: t.hash,
      params: n,
      query: t.query
    } : {
      name: r?.name,
      hash: t.hash,
      params: n,
      query: t.query
    };
  }
  computeGlobalRouteParams() {
    const t = this.store.group, r = this.store.applyMode, n = this.store.currentProviderKey, i = n ? N(n) : null;
    return {
      decision: (n ? this.store.applyResponse(n) || this.store.preauthResponse(n) : null)?.responseCode,
      group: t,
      mode: r,
      providerKey: i
    };
  }
  mergeRoutes(t) {
    return t.map((r) => this.mergeRoute(r));
  }
  mergeRoute(t) {
    let r = t;
    t.children && (r = {
      ...t,
      children: this.mergeRoutes(t.children)
    });
    const n = t.meta?.extends;
    if (!n)
      return r;
    const i = this.routeByName[n];
    if (!i)
      return r;
    const o = i.meta;
    if (!o)
      return r;
    const s = r.meta, a = s ? { ...o, ...s } : o;
    return !a || s === a || (r === t && (r = { ...t }), r.meta = a), r;
  }
  populateRoutes(t) {
    t.forEach((r) => {
      this.populateRoute(r);
    });
  }
  populateRoute(t) {
    if (t.name) {
      const r = t.name;
      if (this.routeByName[r])
        throw new Error(`Route name [${r}] is already defined.`);
      this.routeByName[r] = t;
    }
    t.children && this.populateRoutes(t.children);
  }
}
const Ko = (e) => (t) => e.runWithContext(() => {
  const r = R("GlobalErrorHandler");
  r.error(
    "attempting to recover from preload error ->",
    t.payload.message
  );
  const n = _(), i = n.flowSessionId;
  if (!i) {
    r.error("Unable to recover from preload, no flowSessionId");
    return;
  }
  const o = nr();
  n.persistStoreToSession(i).then(() => {
    const s = new URL(fi());
    s.searchParams.append("go", o.fullPath), s.searchParams.append("returnId", i), window.location.replace(s);
  });
}), Bo = (e) => {
  window.addEventListener("vite:preloadError", Ko(e));
}, Or = {
  install: (e, t) => {
    const r = e.config.globalProperties.$router, n = () => {
      const i = e.runWithContext(
        () => R("GlobalErrorHandler.attemptErrorNavigation")
      );
      x().then(() => r.replace(_o(t))).catch((o) => {
        B(o), i.error(`Failed to navigate to error route ${t}`, o);
      });
    };
    r.onError((i, o, s) => {
      B(i), e.runWithContext(() => {
        const a = R("GlobalErrorHandler"), c = Ve(), l = ee(), d = `Error Routing to ${o.name?.toString()} from ${s.name?.toString()}`;
        a.error(d, i), c.error = i, c.info = d, l({
          type: "error",
          category: "navigation",
          code: "app",
          message: d
        });
      }), n();
    }), e.config.errorHandler = (i, o, s) => {
      B(i), e.runWithContext(() => {
        const a = R("GlobalErrorHandler"), c = Ve();
        a.error(s, i), c.error = i, c.info = s;
        const l = ee();
        i instanceof Yr ? l({
          type: "error",
          category: i.error.category,
          code: i.error.code,
          message: i.error.message,
          cloudRequestId: i.cloudRequestId,
          httpStatusCode: i.statusCode,
          httpMethod: i.httpMethod,
          path: i.path
        }) : l({
          type: "error",
          category: "unknown",
          code: "app",
          message: s
        });
      }), n();
    }, Bo(e);
  }
}, Ze = {
  error: "/error/general",
  exit: "/exit",
  session_restore: "/session/restore",
  session_timeout: "/error/timeout",
  unauthorized: "/error/unauthorized"
}, ko = (e) => (t) => {
  if (typeof t == "boolean")
    return t;
  const r = typeof t == "string" ? e.conditions[t] : t;
  return typeof r == "function" && r({
    route: e.currentRoute.value
  });
}, Tr = /* @__PURE__ */ Symbol("general-route-mappings"), _r = /* @__PURE__ */ Symbol("route-condition-evaluator"), Dr = (e, t, r) => {
  const n = ko({
    currentRoute: t.currentRoute,
    conditions: r
  });
  e.provide(_r, n);
}, Fr = () => ({
  top: 0
}), qo = (e, t) => {
  const r = rr({
    ...t,
    history: ir(t.baseUrl),
    scrollBehavior: t.scrollBehavior ?? Fr
  }), n = {
    ...Ze,
    ...t.generalRouteMappings ?? {}
  };
  r.addRoute({
    name: "__internal.error",
    path: "/internal/error",
    redirect: n.error
  }), r.beforeEach(Xt()), r.beforeEach(br()), r.beforeEach(Rr()), r.afterEach(Er()), r.afterEach(er()), r.afterEach(Fo()), t.customizeRouter && t.customizeRouter(r), e.use(r).use(Or, n.error), Dr(e, r, {});
}, Go = (e, t) => {
  const r = {
    ...t,
    routeConditions: t.routeConditions ?? {},
    generalRouteMappings: t.generalRouteMappings ?? Ze,
    history: ir(t.baseUrl),
    scrollBehavior: t.scrollBehavior ?? Fr
  };
  e.provide(Tr, r.generalRouteMappings);
  const n = new Uo(r, _());
  e.use(n).use(Or, r.generalRouteMappings.error), Dr(e, n, r.routeConditions ?? {});
}, $o = {
  install: (e, t) => {
    t.mode === "complicated" ? Go(e, t) : qo(e, t);
  }
}, Nr = () => ({
  ...Ze,
  ...be(Tr, void 0) ?? {}
}), Vo = () => {
  const e = be(_r);
  if (!e)
    throw new Error("RouteConditionEvaluator has not been provided!");
  return e;
}, Za = (e) => {
  const t = Vo(), r = nr();
  return h(() => t(typeof e == "function" ? e(r.meta) : r.meta[e]));
}, Xa = () => {
  const e = We();
  return () => e.replace({
    name: "__internal.error"
  });
}, Wo = (e, t) => (t.forEach((r) => {
  const n = r.meta || {};
  n.providerKey = e, r.meta = n, r.children && Wo(e, r.children);
}), t), ec = (e, t) => {
  let r;
  const n = e.matched.length;
  return n > 1 ? r = e.matched[n - 2].path : r = e.matched[0].path, `${r}/${t}`;
}, xr = /* @__PURE__ */ Symbol("app-options"), jo = {
  install(e, t) {
    const r = yn();
    if (e.config.globalProperties.$appOptions = t, e.config.globalProperties.$eventBus = r, e.use(fn()), t.mode === "development" && Ti(), e.provide(xr, t).use(t.i18n).use(To, t).use($o, t.router), t.plugins?.forEach((n) => e.use(n)), t.configurePlugins) {
      const n = e.use.bind(e);
      t.configurePlugins(n);
    }
  }
}, Ho = (e) => Jr(e.root).use(jo, e), Lr = () => {
  const e = be(xr) ?? be("app-options");
  if (!e)
    throw new Error("Unable to find active SDK instance, did you install it?");
  return e;
}, tc = (e) => {
  const t = Ho(e);
  return t.mount(e.rootContainer ?? "#app"), zo(), t;
};
function zo() {
  const e = document.body;
  e.classList.add("vc-body"), fr() && e.classList.add("vc-window--has-opener"), mr() && e.classList.add("vc-window--has-parent"), ze() && e.classList.add("vc-window--opened-externally");
}
const Yo = () => {
  let e = !1;
  try {
    e = Lr().mode === "production";
  } catch (t) {
    console.debug(t);
  }
  return h(() => e);
}, R = (e) => {
  const t = Yo(), r = g(), n = _();
  return new Bi(e, t, [
    new ki(),
    new qi(r, n)
  ]);
}, Oe = (e, t, r = { immediate: !0 }) => {
  const n = R("use-polling.ts"), i = async () => {
    let a = !1;
    try {
      await e() && (a = !0);
    } catch (c) {
      n.error("Uncaught error in polling...we'll keep trying", c);
    }
    a || o();
  }, { start: o, stop: s } = ln(
    i,
    t,
    {
      immediate: !1
    }
  );
  return Yt(async () => {
    r.manual || (r.immediate ? await i() : o());
  }), Qt(() => s()), {
    start: o,
    stop: s
  };
};
window.dataLayer ??= [];
class K {
  static GLOBAL;
  _dataLayer = window.dataLayer;
  constructor() {
    this.setInitialEnvironment(), this.listen(), K.GLOBAL || (K.GLOBAL = this);
  }
  set flowSessionId(t) {
    this._dataLayer.push({ apply_session_id: t });
  }
  set environment(t) {
    this._dataLayer.push({ environment: t });
  }
  set groupId(t) {
    this._dataLayer.push({ group_id: t });
  }
  set provider(t) {
    this._dataLayer.push({ current_provider_key: t });
  }
  set applyMode(t) {
    this._dataLayer.push({ current_apply_mode: t });
  }
  push(t) {
    this._dataLayer.push(t);
  }
  setInitialEnvironment() {
    const t = window.location.host;
    t.startsWith("apply-next-demo") ? this.environment = "demo" : t.startsWith("apply-next-test") ? this.environment = "test" : t.startsWith("apply-next-uat") ? this.environment = "uat" : t === "apply-next.versatilecredit.com" || // Whitelabel domains (maybe...) lol
    t.indexOf("versatilecredit") === -1 && t.indexOf(".com") > -1 ? this.environment = "prod" : this.environment = "dev";
    const r = W();
    this.groupId = r.group;
    const n = w();
    this.applyMode = n.applyMode;
    const i = v();
    this.provider = i.currentProviderKey;
    const o = O();
    this.flowSessionId = o.flowSessionId;
  }
  listen() {
    const t = W();
    G(
      () => t.group,
      (o) => this.groupId = o
    );
    const r = w();
    G(
      () => r.applyMode,
      (o) => this.applyMode = o
    );
    const n = v();
    G(
      () => n.currentProviderKey,
      (o) => this.provider = o
    );
    const i = O();
    G(
      () => i.environment,
      (o) => this.environment = o
    ), G(
      () => i.flowSessionId,
      (o) => this.flowSessionId = o
    );
  }
  static getInstance() {
    return K.GLOBAL || (K.GLOBAL = new K()), K.GLOBAL;
  }
}
const rc = (e) => {
  const t = g();
  return {
    exists: (r) => t.checkUserExists(f(e), r)
  };
}, nc = (e) => {
  const t = g();
  return {
    login: (r) => t.providerUserLogin(f(e), r)
  };
}, ic = (e) => {
  const t = g();
  return {
    send: (r) => t.sendProviderUserPasscode(f(e), r)
  };
};
function Qo(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ne, It;
function Jo() {
  if (It) return Ne;
  It = 1;
  var e = function(y) {
    return t(y) && !r(y);
  };
  function t(m) {
    return !!m && typeof m == "object";
  }
  function r(m) {
    var y = Object.prototype.toString.call(m);
    return y === "[object RegExp]" || y === "[object Date]" || o(m);
  }
  var n = typeof Symbol == "function" && Symbol.for, i = n ? /* @__PURE__ */ Symbol.for("react.element") : 60103;
  function o(m) {
    return m.$$typeof === i;
  }
  function s(m) {
    return Array.isArray(m) ? [] : {};
  }
  function a(m, y) {
    return y.clone !== !1 && y.isMergeableObject(m) ? I(s(m), m, y) : m;
  }
  function c(m, y, S) {
    return m.concat(y).map(function(E) {
      return a(E, S);
    });
  }
  function l(m, y) {
    if (!y.customMerge)
      return I;
    var S = y.customMerge(m);
    return typeof S == "function" ? S : I;
  }
  function d(m) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(m).filter(function(y) {
      return Object.propertyIsEnumerable.call(m, y);
    }) : [];
  }
  function p(m) {
    return Object.keys(m).concat(d(m));
  }
  function C(m, y) {
    try {
      return y in m;
    } catch {
      return !1;
    }
  }
  function P(m, y) {
    return C(m, y) && !(Object.hasOwnProperty.call(m, y) && Object.propertyIsEnumerable.call(m, y));
  }
  function b(m, y, S) {
    var E = {};
    return S.isMergeableObject(m) && p(m).forEach(function(M) {
      E[M] = a(m[M], S);
    }), p(y).forEach(function(M) {
      P(m, M) || (C(m, M) && S.isMergeableObject(y[M]) ? E[M] = l(M, S)(m[M], y[M], S) : E[M] = a(y[M], S));
    }), E;
  }
  function I(m, y, S) {
    S = S || {}, S.arrayMerge = S.arrayMerge || c, S.isMergeableObject = S.isMergeableObject || e, S.cloneUnlessOtherwiseSpecified = a;
    var E = Array.isArray(y), M = Array.isArray(m), Br = E === M;
    return Br ? E ? S.arrayMerge(m, y, S) : b(m, y, S) : a(y, S);
  }
  I.all = function(y, S) {
    if (!Array.isArray(y))
      throw new Error("first argument should be an array");
    return y.reduce(function(E, M) {
      return I(E, M, S);
    }, {});
  };
  var q = I;
  return Ne = q, Ne;
}
var Zo = Jo();
const Xo = /* @__PURE__ */ Qo(Zo), oc = () => {
  const e = g(), t = w(), r = v();
  return async (n, i) => {
    const o = await e.accountLookup(n, i), { responseCode: s } = o.applicationResponse;
    switch (s) {
      case "prequalified":
        t.switchApplyMode("prequalify"), r.setPreauthResponse(o.applicationResponse), o.applicationData && (t.application = t.application ? Xo(t.application, o.applicationData) : structuredClone(o.applicationData));
        break;
      case "approved":
        t.switchApplyMode("full"), r.setApplyResponse(o.applicationResponse);
        break;
    }
    return o;
  };
}, sc = [
  { id: "AL", name: "AL" },
  { id: "AK", name: "AK" },
  { id: "AZ", name: "AZ" },
  { id: "AR", name: "AR" },
  { id: "AA", name: "AA" },
  { id: "AE", name: "AE" },
  { id: "AP", name: "AP" },
  { id: "AS", name: "AS" },
  { id: "CA", name: "CA" },
  { id: "CO", name: "CO" },
  { id: "CT", name: "CT" },
  { id: "DC", name: "DC" },
  { id: "DE", name: "DE" },
  { id: "FL", name: "FL" },
  { id: "FM", name: "FM" },
  { id: "GA", name: "GA" },
  { id: "GU", name: "GU" },
  { id: "HI", name: "HI" },
  { id: "ID", name: "ID" },
  { id: "IL", name: "IL" },
  { id: "IN", name: "IN" },
  { id: "IA", name: "IA" },
  { id: "KS", name: "KS" },
  { id: "KY", name: "KY" },
  { id: "LA", name: "LA" },
  { id: "ME", name: "ME" },
  { id: "MD", name: "MD" },
  { id: "MA", name: "MA" },
  { id: "MI", name: "MI" },
  { id: "MN", name: "MN" },
  { id: "MS", name: "MS" },
  { id: "MO", name: "MO" },
  { id: "MT", name: "MT" },
  { id: "MH", name: "MH" },
  { id: "MP", name: "MP" },
  { id: "NE", name: "NE" },
  { id: "NV", name: "NV" },
  { id: "NH", name: "NH" },
  { id: "NJ", name: "NJ" },
  { id: "NM", name: "NM" },
  { id: "NY", name: "NY" },
  { id: "NC", name: "NC" },
  { id: "ND", name: "ND" },
  { id: "OH", name: "OH" },
  { id: "OK", name: "OK" },
  { id: "OR", name: "OR" },
  { id: "PA", name: "PA" },
  { id: "PR", name: "PR" },
  { id: "PW", name: "PW" },
  { id: "RI", name: "RI" },
  { id: "SC", name: "SC" },
  { id: "SD", name: "SD" },
  { id: "TN", name: "TN" },
  { id: "TX", name: "TX" },
  { id: "UT", name: "UT" },
  { id: "VT", name: "VT" },
  { id: "VA", name: "VA" },
  { id: "VI", name: "VI" },
  { id: "WA", name: "WA" },
  { id: "WV", name: "WV" },
  { id: "WI", name: "WI" },
  { id: "WY", name: "WY" }
], ac = [
  { id: "USA", name: "United States of America" },
  { id: "AFG", name: "Afghanistan" },
  { id: "ALB", name: "Albania" },
  { id: "DZA", name: "Algeria" },
  { id: "ASM", name: "American Samoa" },
  { id: "AND", name: "Andorra" },
  { id: "AGO", name: "Angola" },
  { id: "AIA", name: "Anguilla" },
  { id: "ATA", name: "Antarctica" },
  { id: "ATG", name: "Antigua and Barbuda" },
  { id: "ARG", name: "Argentina" },
  { id: "ARM", name: "Armenia" },
  { id: "ABW", name: "Aruba " },
  { id: "AUS", name: "Australia" },
  { id: "AUT", name: "Austria" },
  { id: "AZE", name: "Azerbaijan" },
  { id: "BHS", name: "Bahamas" },
  { id: "BHR", name: "Bahrain" },
  { id: "BGD", name: "Bangladesh" },
  { id: "BRB", name: "Barbados" },
  { id: "BLR", name: "Belarus" },
  { id: "BEL", name: "Belgium" },
  { id: "BLZ", name: "Belize" },
  { id: "BEN", name: "Benin" },
  { id: "BMU", name: "Bermuda" },
  { id: "BTN", name: "Bhutan" },
  { id: "BOL", name: "Bolivia (Plurinational State of)" },
  { id: "BES", name: "Bonaire, Sint Eustatius and Saba" },
  { id: "BIH", name: "Bosnia and Herzegovina" },
  { id: "BWA", name: "Botswana" },
  { id: "BVT", name: "Bouvet Island" },
  { id: "BRA", name: "Brazil" },
  { id: "IOT", name: "British Indian Ocean Territory" },
  { id: "BRN", name: "Brunei Darussalam" },
  { id: "BGR", name: "Bulgaria" },
  { id: "BFA", name: "Burkina Faso" },
  { id: "BDI", name: "Burundi" },
  { id: "CPV", name: "Cabo Verde" },
  { id: "KHM", name: "Cambodia" },
  { id: "CMR", name: "Cameroon" },
  { id: "CAN", name: "Canada" },
  { id: "CYM", name: "Cayman Islands" },
  { id: "CAF", name: "Central African Republic" },
  { id: "TCD", name: "Chad" },
  { id: "CHL", name: "Chile" },
  { id: "CHN", name: "China" },
  { id: "CXR", name: "Christmas Island" },
  { id: "CCK", name: "Cocos (Keeling) Islands" },
  { id: "COL", name: "Colombia" },
  { id: "COM", name: "Comoros" },
  { id: "COD", name: "Congo (the Democratic Republic of the)" },
  { id: "COG", name: "Congo" },
  { id: "COK", name: "Cook Islands" },
  { id: "CRI", name: "Costa Rica" },
  { id: "HRV", name: "Croatia" },
  { id: "CUB", name: "Cuba" },
  { id: "CUW", name: "Curaçao" },
  { id: "CYP", name: "Cyprus" },
  { id: "CZE", name: "Czechia" },
  { id: "CIV", name: "Côte d'Ivoire" },
  { id: "DNK", name: "Denmark" },
  { id: "DJI", name: "Djibouti" },
  { id: "DMA", name: "Dominica" },
  { id: "DOM", name: "Dominican Republic" },
  { id: "ECU", name: "Ecuador" },
  { id: "EGY", name: "Egypt" },
  { id: "SLV", name: "El Salvador" },
  { id: "GNQ", name: "Equatorial Guinea" },
  { id: "ERI", name: "Eritrea" },
  { id: "EST", name: "Estonia" },
  { id: "SWZ", name: "Eswatini" },
  { id: "ETH", name: "Ethiopia" },
  { id: "FLK", name: "Falkland Islands" },
  { id: "FRO", name: "Faroe Islands" },
  { id: "FJI", name: "Fiji" },
  { id: "FIN", name: "Finland" },
  { id: "FRA", name: "France" },
  { id: "GUF", name: "French Guiana" },
  { id: "PYF", name: "French Polynesia" },
  { id: "ATF", name: "French Southern Territories" },
  { id: "GAB", name: "Gabon" },
  { id: "GMB", name: "Gambia" },
  { id: "GEO", name: "Georgia" },
  { id: "DEU", name: "Germany" },
  { id: "GHA", name: "Ghana" },
  { id: "GIB", name: "Gibraltar" },
  { id: "GRC", name: "Greece" },
  { id: "GRL", name: "Greenland" },
  { id: "GRD", name: "Grenada" },
  { id: "GLP", name: "Guadeloupe" },
  { id: "GUM", name: "Guam" },
  { id: "GTM", name: "Guatemala" },
  { id: "GGY", name: "Guernsey" },
  { id: "GIN", name: "Guinea" },
  { id: "GNB", name: "Guinea-Bissau" },
  { id: "GUY", name: "Guyana" },
  { id: "HTI", name: "Haiti" },
  { id: "HMD", name: "Heard Island and McDonald Islands" },
  { id: "VAT", name: "Holy See" },
  { id: "HND", name: "Honduras" },
  { id: "HKG", name: "Hong Kong" },
  { id: "HUN", name: "Hungary" },
  { id: "ISL", name: "Iceland" },
  { id: "IND", name: "India" },
  { id: "IDN", name: "Indonesia" },
  { id: "IRN", name: "Iran" },
  { id: "IRQ", name: "Iraq" },
  { id: "IRL", name: "Ireland" },
  { id: "IMN", name: "Isle of Man" },
  { id: "ISR", name: "Israel" },
  { id: "ITA", name: "Italy" },
  { id: "JAM", name: "Jamaica" },
  { id: "JPN", name: "Japan" },
  { id: "JEY", name: "Jersey" },
  { id: "JOR", name: "Jordan" },
  { id: "KAZ", name: "Kazakhstan" },
  { id: "KEN", name: "Kenya" },
  { id: "KIR", name: "Kiribati" },
  { id: "PRK", name: "Korea (the Democratic People's Republic of)" },
  { id: "KOR", name: "Korea (the Republic of)" },
  { id: "KWT", name: "Kuwait" },
  { id: "KGZ", name: "Kyrgyzstan" },
  { id: "LAO", name: "Lao People's Democratic Republic" },
  { id: "LVA", name: "Latvia" },
  { id: "LBN", name: "Lebanon" },
  { id: "LSO", name: "Lesotho" },
  { id: "LBR", name: "Liberia" },
  { id: "LBY", name: "Libya" },
  { id: "LIE", name: "Liechtenstein" },
  { id: "LTU", name: "Lithuania" },
  { id: "LUX", name: "Luxembourg" },
  { id: "MAC", name: "Macao" },
  { id: "MDG", name: "Madagascar" },
  { id: "MWI", name: "Malawi" },
  { id: "MYS", name: "Malaysia" },
  { id: "MDV", name: "Maldives" },
  { id: "MLI", name: "Mali" },
  { id: "MLT", name: "Malta" },
  { id: "MHL", name: "Marshall Islands" },
  { id: "MTQ", name: "Martinique" },
  { id: "MRT", name: "Mauritania" },
  { id: "MUS", name: "Mauritius" },
  { id: "MYT", name: "Mayotte" },
  { id: "MEX", name: "Mexico" },
  { id: "FSM", name: "Micronesia" },
  { id: "MDA", name: "Moldova" },
  { id: "MCO", name: "Monaco" },
  { id: "MNG", name: "Mongolia" },
  { id: "MNE", name: "Montenegro" },
  { id: "MSR", name: "Montserrat" },
  { id: "MAR", name: "Morocco" },
  { id: "MOZ", name: "Mozambique" },
  { id: "MMR", name: "Myanmar" },
  { id: "NAM", name: "Namibia" },
  { id: "NRU", name: "Nauru" },
  { id: "NPL", name: "Nepal" },
  { id: "NLD", name: "Netherlands" },
  { id: "NCL", name: "New Caledonia" },
  { id: "NZL", name: "New Zealand" },
  { id: "NIC", name: "Nicaragua" },
  { id: "NER", name: "Niger" },
  { id: "NGA", name: "Nigeria" },
  { id: "NIU", name: "Niue" },
  { id: "NFK", name: "Norfolk Island" },
  { id: "MNP", name: "Northern Mariana Islands" },
  { id: "NOR", name: "Norway" },
  { id: "OMN", name: "Oman" },
  { id: "PAK", name: "Pakistan" },
  { id: "PLW", name: "Palau" },
  { id: "PSE", name: "Palestine, State of" },
  { id: "PAN", name: "Panama" },
  { id: "PNG", name: "Papua New Guinea" },
  { id: "PRY", name: "Paraguay" },
  { id: "PER", name: "Peru" },
  { id: "PHL", name: "Philippines" },
  { id: "PCN", name: "Pitcairn" },
  { id: "POL", name: "Poland" },
  { id: "PRT", name: "Portugal" },
  { id: "PRI", name: "Puerto Rico" },
  { id: "QAT", name: "Qatar" },
  { id: "MKD", name: "Republic of North Macedonia" },
  { id: "ROU", name: "Romania" },
  { id: "RUS", name: "Russian Federation" },
  { id: "RWA", name: "Rwanda" },
  { id: "REU", name: "Réunion" },
  { id: "BLM", name: "Saint Barthélemy" },
  { id: "SHN", name: "Saint Helena, Ascension and Tristan da Cunha" },
  { id: "KNA", name: "Saint Kitts and Nevis" },
  { id: "LCA", name: "Saint Lucia" },
  { id: "MAF", name: "Saint Martin (French part)" },
  { id: "SPM", name: "Saint Pierre and Miquelon" },
  { id: "VCT", name: "Saint Vincent and the Grenadines" },
  { id: "WSM", name: "Samoa" },
  { id: "SMR", name: "San Marino" },
  { id: "STP", name: "Sao Tome and Principe" },
  { id: "SAU", name: "Saudi Arabia" },
  { id: "SEN", name: "Senegal" },
  { id: "SRB", name: "Serbia" },
  { id: "SYC", name: "Seychelles" },
  { id: "SLE", name: "Sierra Leone" },
  { id: "SGP", name: "Singapore" },
  { id: "SXM", name: "Sint Maarten (Dutch part)" },
  { id: "SVK", name: "Slovakia" },
  { id: "SVN", name: "Slovenia" },
  { id: "SLB", name: "Solomon Islands" },
  { id: "SOM", name: "Somalia" },
  { id: "ZAF", name: "South Africa" },
  { id: "SGS", name: "South Georgia and the South Sandwich Islands" },
  { id: "SSD", name: "South Sudan" },
  { id: "ESP", name: "Spain" },
  { id: "LKA", name: "Sri Lanka" },
  { id: "SDN", name: "Sudan" },
  { id: "SUR", name: "Suriname" },
  { id: "SJM", name: "Svalbard and Jan Mayen" },
  { id: "SWE", name: "Sweden" },
  { id: "CHE", name: "Switzerland" },
  { id: "SYR", name: "Syrian Arab Republic" },
  { id: "TWN", name: "Taiwan (Province of China)" },
  { id: "TJK", name: "Tajikistan" },
  { id: "TZA", name: "Tanzania, United Republic of" },
  { id: "THA", name: "Thailand" },
  { id: "TLS", name: "Timor-Leste" },
  { id: "TGO", name: "Togo" },
  { id: "TKL", name: "Tokelau" },
  { id: "TON", name: "Tonga" },
  { id: "TTO", name: "Trinidad and Tobago" },
  { id: "TUN", name: "Tunisia" },
  { id: "TUR", name: "Turkey" },
  { id: "TKM", name: "Turkmenistan" },
  { id: "TCA", name: "Turks and Caicos Islands" },
  { id: "TUV", name: "Tuvalu" },
  { id: "UGA", name: "Uganda" },
  { id: "UKR", name: "Ukraine" },
  { id: "ARE", name: "United Arab Emirates" },
  { id: "GBR", name: "United Kingdom of Great Britain and Northern Ireland" },
  { id: "UMI", name: "United States Minor Outlying Islands" },
  { id: "URY", name: "Uruguay" },
  { id: "UZB", name: "Uzbekistan" },
  { id: "VUT", name: "Vanuatu" },
  { id: "VEN", name: "Venezuela" },
  { id: "VNM", name: "Viet Nam" },
  { id: "VGB", name: "Virgin Islands (British)" },
  { id: "VIR", name: "Virgin Islands (U.S.)" },
  { id: "WLF", name: "Wallis and Futuna" },
  { id: "ESH", name: "Western Sahara" },
  { id: "YEM", name: "Yemen" },
  { id: "ZMB", name: "Zambia" },
  { id: "ZWE", name: "Zimbabwe" },
  { id: "ALA", name: "Åland Islands" }
], cc = (e, t) => {
  const r = g();
  return fe(
    (n) => r.deliverApplicationDocuments(f(e), n),
    t
  );
}, lc = (e, t, r) => {
  const n = g();
  return Oe(async () => {
    const o = await n.verifyApplicationDocumentsDelivery(
      f(e),
      f(t)
    );
    return await r(o.verified), o.verified;
  }, 1e4, {
    immediate: !1,
    manual: !0
  });
}, es = /^(\d{3})(\d{3})(\d{4})$/, ts = /^(\d)(\d{3})(\d{3})(\d{4})$/, dc = (e, t) => {
  const r = ("" + e).replace(/\D/g, ""), n = es.exec(r), i = ts.exec(r);
  return i ? rs(i, t) : n ? ns(n, t) : null;
};
function rs(e, t) {
  return t == null || t == "parenthetical" ? `${e[1]} (${e[2]}) ${e[3]}-${e[4]}` : `${e[1]}-${e[2]}-${e[3]}-${e[4]}`;
}
function ns(e, t) {
  return t == null || t === "parenthetical" ? `(${e[1]}) ${e[2]}-${e[3]}` : `${e[1]}-${e[2]}-${e[3]}`;
}
function uc(e) {
  if (isNaN(e) || !Number.isInteger(e))
    return "Invalid input: Not an integer";
  const t = e % 10, r = e % 100;
  if (r >= 11 && r <= 13)
    return e + "th";
  switch (t) {
    case 1:
      return e + "st";
    case 2:
      return e + "nd";
    case 3:
      return e + "rd";
    default:
      return e + "th";
  }
}
const pc = (e, t = 4, r = "-") => {
  if (!e)
    return e;
  const n = new RegExp(`.{1,${t}}`, "g");
  return e.match(n)?.join(r);
}, fc = (e) => {
  const t = ("" + e).replace(/\D/g, ""), n = /^(\d{3})(\d{2})(\d{4})$/.exec(t);
  return n ? `${n[1]}-${n[2]}-${n[3]}` : null;
}, mc = (e) => {
  const t = ("" + e).replace(/\D/g, ""), n = /^(\d{3})(\d{2})(\d{4})$/.exec(t);
  return n ? `${n[3]}` : null;
}, hc = (e) => {
  const t = g(), r = v();
  return async (n) => {
    const i = f(e), o = await t.answerQuiz(i, n);
    if (o.status === "pending" && o.providerId === "acima") {
      const a = (await t.checkApplication(i)).provider;
      if (a) {
        r.setApplyResponse(a);
        const c = a.quizResponse?.quizId ? a.quizResponse : void 0;
        return {
          ...o,
          // If the quiz id is the same as the current quiz then it has failed
          // If the quiz id is different then another quiz needs to be completed
          status: c?.quizId === n.quizId ? "fail" : "pass",
          next: c
        };
      }
    }
    return o;
  };
}, yc = (e, t) => {
  const r = v();
  return h(() => {
    const i = r.findApplyResponse(f(e))?.quizResponse;
    return i?.quizId === f(t) ? i : void 0;
  });
}, vc = () => an(W()), gc = (e) => {
  const t = W(), r = cn({
    inheritLocale: !1
  }), n = je({
    useScope: "global"
  }), i = () => {
    const o = f(e), s = `${o ? N(o) : "all"}_${t.language}`, a = `${o ? N(o) : "all"}_${t.locale}`;
    r.locale.value = a, r.fallbackLocale.value = [
      s,
      ...n.fallbackLocale.value
    ];
    const c = n.messages.value;
    a in c && r.mergeLocaleMessage(a, c[a]), s in c && r.mergeLocaleMessage(s, c[s]);
  };
  return Zr(() => i()), G(
    () => t.locale,
    () => i()
  ), r;
}, Pc = {
  legacy: !1,
  /**
   * The locale of localization.
   *
   * If the locale contains a territory and a dialect,
   * this locale contains an implicit fallback.
   *
   * @see https://vue-i18n.intlify.dev/api/composition.html#locale-1
   */
  locale: "en",
  /**
   * The locale of fallback localization.
   *
   * @see https://vue-i18n.intlify.dev/api/composition.html#fallbacklocale-1
   */
  fallbackLocale: ["en"],
  /**
   * In the component localization, whether to fall back to root level (global scope)
   * localization when localization fails.
   *
   * @see https://vue-i18n.intlify.dev/api/composition.html#fallbackroot-1
   */
  fallbackRoot: !0,
  /**
   * Whether suppress warnings outputted when localization fails.
   *
   * @see https://vue-i18n.intlify.dev/api/composition.html#missingwarn-1
   */
  missingWarn: !1,
  /**
   * Whether suppress warnings when falling back to either fallbackLocale or root.
   *
   * @see https://vue-i18n.intlify.dev/api/composition.html#fallbackwarn-1
   */
  fallbackWarn: !1
}, wc = (e) => {
  const t = g(), r = R("useLaunchMobileApply"), n = async () => await t.launchFromMobileDevice(
    is(e)
  ), { error: i, isLoading: o, isReady: s, state: a, execute: c, executeImmediate: l } = ue(
    n,
    {
      success: !1
    },
    {
      immediate: !1,
      onError: (d) => r.error("Failed to launch on mobile device ", d)
    }
  );
  return {
    error: i,
    isLoading: o,
    isReady: s,
    state: a,
    refresh: c,
    submit: l
  };
}, is = (e) => {
  const t = w(), r = f(e);
  switch (r) {
    case "sms":
      return {
        mobilePhone: t.getApplicationValue(
          "primary.mobilePhone"
        )
      };
    case "email":
      return {
        email: t.getApplicationValue("primary.email")
      };
    default:
      throw new Error(
        `${r} is not supported. Try something else!`
      );
  }
}, Ac = (e) => {
  const t = g(), r = R("useQrCodeLaunch"), n = async () => {
    const l = f(e);
    return await t.launchApplicationFromQrCode({
      config: {
        startAt: l.startAt,
        prefill: {
          primaryApplicant: os()
        }
      }
    });
  }, { error: i, isLoading: o, isReady: s, state: a, execute: c } = ue(
    n,
    {
      url: void 0,
      expires: void 0
    },
    {
      onError: (l) => r.error("Failed to fetch QR code ", l)
    }
  );
  return {
    error: i,
    isLoading: o,
    isReady: s,
    state: a,
    refresh: c
  };
}, os = () => {
  const e = w();
  return {
    firstName: e.getApplicationValue("primary.firstName"),
    lastName: e.getApplicationValue("primary.lastName"),
    dateOfBirth: e.getApplicationValue("primary.dateOfBirth"),
    email: e.getApplicationValue("primary.email"),
    homePhone: e.getApplicationValue("primary.homePhone"),
    mobilePhone: e.getApplicationValue("primary.mobilePhone"),
    address: {
      line1: e.getApplicationValue("primary.homeAddress.line1"),
      line2: e.getApplicationValue("primary.homeAddress.line2"),
      city: e.getApplicationValue("primary.homeAddress.city"),
      state: e.getApplicationValue("primary.homeAddress.state"),
      zipCode: e.getApplicationValue(
        "primary.homeAddress.zipCode"
      )
    }
  };
}, Sc = () => {
  const e = Ye(), { t, te: r } = je({
    useScope: "parent"
  });
  return h(
    () => e.name ?? (r("merchant.name") ? t("merchant.name") : void 0)
  );
}, Rc = () => {
  const e = Ye(), { t } = je({
    useScope: "parent"
  });
  return h(() => e.legalName ?? t("merchant.legal_name"));
}, bc = (e, t) => {
  const r = R("useFetchZipCodeMetadata()"), n = g(), i = F(!1), o = fe(async (a) => {
    try {
      const c = await n.getZipCodeMetadata(a);
      t(c), await x();
    } catch (c) {
      B(c), r.error("Failed to fetch zip code metadata", c);
    }
  }, i), s = dn(
    () => f(e),
    (a) => {
      if (a != null && a.length >= 5)
        return o(a);
    }
  );
  return Qt(() => {
    s();
  }), h(() => i.value);
}, Ur = () => {
  const e = R("useApplicablePreauthResponses"), t = gr(), r = v();
  return h(() => {
    const n = f(t), i = r.findProviderConfig(n);
    return i == null ? (e.error(
      `Unable to determine offers, config for ${n} is missing`
    ), []) : r.preauthResponses.filter((o) => {
      const { responseCode: s, providerKey: a } = o, c = r.findProviderConfig(a);
      return c == null ? (e.warn(`Skipping response for ${a}, config is missing`), !1) : s !== u.PREQUALIFIED && s !== u.PREAPPROVED ? !1 : a === n ? !0 : r.findApplyResponse(a) ? !1 : i.cascadeGroup === c.cascadeGroup;
    });
  });
}, xe = (e, t) => [e, t].join(":"), ss = (e) => e.filter(
  (t) => t.providerProductType == null || t.providerProductType === "credit"
), as = (e) => e.filter(
  (t) => t.providerProductType === "loan" || t.providerProductType === "bnpl"
), Mt = (e) => {
  const t = e.map((r) => r.approvedAmountCents).filter((r) => r != null);
  return Math.max(...t);
}, Ec = (e) => {
  const t = v(), r = Ur(), n = (o) => {
    const s = t.findProviderConfig(o.providerKey), a = t.findPaymentPlans(o.providerKey), c = (d) => An(
      d,
      a.sort?.byFields ?? [
        "monthlyAmountCents",
        "paymentAmountCents",
        "minAmountCents",
        "providerKey"
      ]
    );
    if (o.providerId === "synchrony" && s?.providerProduct === "synchrony-multi-product") {
      const d = [], p = ss(a.paymentPlans);
      if (p.length > 0) {
        const P = structuredClone(ot(o));
        P.approvedAmountCents = Mt(p), d.push({
          id: xe(o.providerKey, "credit"),
          providerKey: o.providerKey,
          response: P,
          plans: c(p),
          productType: "credit",
          partialCoverage: !1
        });
      }
      const C = as(a.paymentPlans);
      if (C.length > 0) {
        const P = structuredClone(ot(o));
        P.approvedAmountCents = Mt(C), d.push({
          id: xe(o.providerKey, "loan"),
          providerKey: o.providerKey,
          response: P,
          plans: c(C),
          productType: "loan",
          partialCoverage: !1
        });
      }
      return d;
    }
    const l = c(a.paymentPlans);
    return [
      {
        id: xe(o.providerKey, "unknown"),
        providerKey: o.providerKey,
        response: o,
        plans: l,
        productType: s?.providerProductType,
        partialCoverage: !1
      }
    ];
  }, i = (o, s) => {
    const a = t.cascade.findIndex(
      (l) => l.providerKey === o.providerKey
    ) ?? 0, c = t.cascade.findIndex(
      (l) => l.providerKey === s.providerKey
    ) ?? 0;
    return a - c;
  };
  return h(
    () => f(r).flatMap((o) => n(o)).filter(
      (o) => o != null && e.has(o.response.providerId)
    ).sort((o, s) => i(o, s))
  );
}, Cc = (e) => {
  const t = Ur();
  return h(
    () => t.value.every(({ providerId: r }) => e.has(r))
  );
}, cs = [
  u.PREQUALIFIED,
  u.PREAPPROVED,
  u.APPROVED
], ls = (e) => e && cs.includes(e.responseCode), Ot = () => ({
  paymentPlans: []
}), ds = (e) => {
  const t = U(e.providerKey);
  return ls(e) || t.fetchPaymentPlansOnError;
}, us = (e, t, r, n) => {
  if (e.providerId != "synchrony" || t == null || r.paymentPlans.length == 0)
    return n;
  const i = r.paymentPlans.filter(
    (s) => t === "credit" ? (
      // Keep Loan Plans, replacing Credit Plans
      s.providerProductType !== "credit"
    ) : (
      // Keep Credit Plans, replacing Loan Plans
      s.providerProductType === "credit"
    )
  ), o = n.paymentPlans.filter(
    (s) => t === "credit" ? (
      // Keep new Credit Plans
      s.providerProductType === "credit"
    ) : (
      // Keep NEW Loan Plans
      s.providerProductType !== "credit"
    )
  );
  return {
    ...n,
    paymentPlans: [...i, ...o]
  };
}, ps = (e = {}) => {
  const t = R("useFetchPaymentPlans"), r = g(), n = Zi(e.providerKey), i = v(), o = de(), s = Xi();
  return async (a) => {
    const c = f(n);
    if (c?.providerKey == null)
      return t.error("Unable to fetch payment plans, provider is not known"), Ot();
    const l = c.providerKey;
    if (ds(c)) {
      const d = c.approvedAmountCents ?? 0, p = a?.purchaseAmount ?? o.value ?? d, C = a?.downPaymentAmount ?? Ee(
        d,
        p,
        a?.downPaymentAmount ?? s.value
      ), P = await r.getPaymentPlans(
        c.providerKey,
        p,
        C
      ), b = i.findPaymentPlans(c.providerKey), I = us(
        c,
        a?.productType,
        b,
        P
      );
      return i.setPaymentPlans(c.providerKey, I), P;
    } else
      return t.warn(
        `Refusing to fetch payment plans for: ${l} with response code: ${c.responseCode}`
      ), Ot();
  };
}, fs = (e, t) => h(() => {
  const r = f(e);
  return f(t).find((n) => n.id === r);
}), ms = (e) => h(() => {
  const t = f(e);
  if (t?.productType === "loan" || t?.productType === "bnpl") {
    const r = t.plans.map((n) => n.minAmountCents).filter((n) => n !== void 0);
    if (r.length)
      return Math.max(Math.min(...r), 1);
  }
  return 1;
}), hs = (e, t) => h(() => {
  const r = e.value?.response;
  if (!r)
    return 0;
  const n = U(r.providerId), i = r.approvedAmountCents ?? 0, o = n.excludePurchaseAmountFromMaxFinancing ? Number.MAX_SAFE_INTEGER : t.value;
  return Math.min(i, o);
}), Ic = (e, t) => {
  const r = f(t), n = w(), i = fs(e, r), o = h(() => i.value?.providerKey), s = h(
    () => n.getApplicationValue("purchaseAmountCents") ?? 0
  ), a = F(s.value), c = F(!1), l = ps({
    providerKey: o
  }), d = ms(i), p = hs(
    i,
    a
  ), C = tr(
    (b, I) => {
      if (I == null)
        return;
      const q = f(i)?.productType;
      return l({
        purchaseAmount: b,
        productType: q
      });
    }
  ), P = un(async (b) => {
    if (!(b > p.value) && !(b < d.value)) {
      c.value = !0;
      try {
        return await C(b, f(o));
      } finally {
        c.value = !1;
      }
    }
  }, 500);
  return G(a, P), G(i, (b, I) => {
    if (I?.id !== b?.id) {
      const q = b?.response?.approvedAmountCents, m = s.value;
      a.value = q == null ? m : Math.min(q, m);
    }
  }), {
    fetchingPlans: c,
    financedAmountCents: a,
    minFinanceAmountCents: d,
    maxFinanceAmountCents: p
  };
}, ys = () => {
  const e = w();
  return h({
    get: () => e.selectedPlan,
    set: (t) => e.selectedPlan = t
  });
}, Mc = (e, t) => {
  const r = v();
  return h(() => {
    const n = f(e), i = f(t), o = r.findPaymentPlan(n, i);
    if (!o)
      throw new Error(`${i} was not found for ${n}`);
    return o;
  });
}, Oc = (e) => {
  const t = R("useReviewOffer"), r = v(), n = ys(), i = F(), o = de(i), s = Je();
  return fe(async (a, c, l, d) => {
    if (a == null) {
      t.warn("Refusing to review offer, provider key is undefined");
      return;
    }
    const p = Hi(() => a);
    i.value = a;
    const C = h(
      () => !!p.value?.requiresSelectPlan
    );
    if (c == null && C.value) {
      t.warn("Refusing to review offer, plan is undefined");
      return;
    }
    c != null && (n.value = c), l != null && (o.value = l);
    const b = r.findProviderConfig(a)?.applyModes?.find((I) => I !== "full");
    a !== r.currentProviderKey && (t.info(
      "Switching to new provider:",
      a,
      "and apply mode:",
      b
    ), await s({
      providerKey: a,
      applyMode: b
    })), await d();
  }, e);
}, Tc = (e) => {
  const t = R("useSelectOffer"), r = v(), n = Yi(), i = Je();
  return fe(async (o, s, a) => {
    const l = Pr(() => o).value?.applyModes?.find((d) => d !== "full");
    o !== r.currentProviderKey && (t.info(
      "Switching to new provider:",
      o,
      "and apply mode:",
      l
    ), await i({
      providerKey: o,
      applyMode: l
    })), t.info(
      "Selecting payment plan:",
      s.providerKey,
      " -> ",
      s.providerPlanCode
    ), await n.selectPaymentPlan(s), await a();
  }, e);
};
var Le, Tt;
function vs() {
  return Tt || (Tt = 1, Le = {}), Le;
}
var _c = vs();
const gs = () => window.webKiosk;
class Kr {
}
class Ps extends Kr {
  constructor(t, r) {
    super(), this._settings = t, this._printer = r;
  }
  _settings;
  _printer;
  documentFormat = "pdf";
  get printerName() {
    return this._settings.printerName;
  }
  get pageWidth() {
    return this._settings.pageWidth;
  }
  get pageHeight() {
    return this._settings.pageHeight ?? 11;
  }
  print(t) {
    const r = new Blob([t], {
      type: "application/pdf"
    });
    return this._printer.print(this.printerName, r);
  }
}
class ws extends Kr {
  pageHeight = 11;
  pageWidth = 8.5;
  printerName = "system";
  documentFormat = "html";
  async print(t) {
    const r = new Blob([t], {
      type: "text/html"
    }), n = await this.toHtml(r);
    return new Promise((i, o) => {
      Pn({
        printable: n,
        type: "raw-html",
        onError: (s) => o(s),
        onPrintDialogClose: () => i()
      });
    });
  }
  async toHtml(t) {
    return (await t.text()).replace("size: 3.5in;", "size: letter;").replace("margin: 0;", "margin: 1in;").replace(
      'style="max-width: 100%; height: auto;"',
      'style="max-width: 3.5in; height: auto;"'
    );
  }
}
const As = () => {
  const e = R("useReceiptPrinter"), t = gs();
  return async () => {
    if (t) {
      const r = await t.printer.getSettings();
      if (r)
        return e.info(`Using Ticket Printer: ${r.printerName}`), new Ps(r, t.printer);
    }
    return e.info("Using Ticket Printer: system"), new ws();
  };
}, Dc = (e) => {
  const t = g(), r = As();
  return async (n) => {
    e.value = !0;
    try {
      const i = await r();
      if (i == null)
        throw new Error("No Receipt Printer found!");
      const o = {
        printerName: i.printerName,
        pageWidth: i.pageWidth,
        pageHeight: i.pageHeight,
        format: i.documentFormat
      }, s = await t.generateReceipt(n.providerKey, o);
      return i.print(s);
    } finally {
      e.value = !1;
    }
  };
}, Fc = () => {
  const e = O();
  return h(() => e.extensions.find((r) => r.featureId === "prove")?.properties);
}, Nc = () => {
  const e = g();
  return () => e.proveResendSms();
}, Te = k("prove", {
  state: () => ({
    invalidFields: void 0,
    mobilePhone: void 0,
    prefillFields: void 0,
    ssnLast4: void 0,
    linkClicked: !1,
    completed: !1
  }),
  getters: {
    application: () => w().application,
    phoneLast4: (e) => {
      const t = e.mobilePhone;
      if (t != null)
        return t.length > 4 ? t.substring(t.length - 4) : t;
    }
  }
}), xc = () => {
  const e = g(), t = Te();
  return async (r) => {
    const n = await e.proveSendSms(r);
    return n.status === "success" && t.$patch({
      ...r
    }), n;
  };
}, Lc = () => {
  const e = j(), t = Te(), r = w();
  return async () => {
    r.$patch({
      application: {
        primary: {
          mobilePhone: t.mobilePhone
        }
      }
    });
    const n = t.invalidFields?.map(
      (a) => a.fieldPath
    ) ?? [], i = [
      [
        "primary.firstName",
        "primary.middleInitial",
        "primary.lastName",
        "primary.nameSuffix"
      ],
      ["primary.dateOfBirth"],
      ["primary.ssn"],
      ["primary.mobilePhone"],
      [
        "primary.homeAddress.line1",
        "primary.homeAddress.line2",
        "primary.homeAddress.city",
        "primary.homeAddress.state",
        "primary.homeAddress.zipCode"
      ]
    ], o = i.flatMap((a) => a);
    t.prefillFields?.length || (t.prefillFields = e.getFieldsByPath(...o));
    const s = n.map(
      (a) => i.find((c) => c.includes(a)) ?? [a]
    ).flatMap((a) => a);
    e.removeFieldsByPath(
      ...o.filter(
        (a) => !s.includes(a)
      )
    ), await x();
  };
}, Uc = (e) => {
  const t = g(), r = Te(), n = F();
  Oe(async () => {
    const o = await t.getProveSmsStatus();
    return o.status === "clicked" && (r.$patch({
      linkClicked: !0
    }), await x()), o.status !== n.value?.status && (n.value = o, await e(o)), o.status !== "sent";
  }, 5e3);
}, Kc = (e) => {
  const t = g(), r = w(), n = Te(), i = te(), o = F();
  Oe(async () => {
    const a = f(i), c = await t.getProveVerificationResult(a);
    if (c.status === "verified") {
      const l = c.applicationData;
      n.completed = !0, n.invalidFields = c.validationResult?.failures, l?.primary?.ssn && delete l.primary.ssn, r.$patch({
        application: {
          ...structuredClone(l)
        },
        originalApplication: {
          hasAgreedToCascade: r.application?.hasAgreedToCascade,
          ...structuredClone(l)
        }
      }), await x();
    }
    return c.status !== o.value?.status && (o.value = c, await e(c)), c.status !== "pending";
  }, 5e3);
}, Bc = (e) => {
  const t = g(), r = R("useMpqDeliveryDetails"), { error: n, state: i, isLoading: o, isReady: s } = ue(
    () => t.getSynchronyMpqDeliveryDetails(f(e)),
    void 0,
    {
      onError(a) {
        r.error("Failed getting mpq delivery details", a), B(a);
      }
    }
  );
  return {
    error: n,
    state: i,
    isLoading: o,
    isReady: s
  };
}, kc = (e) => {
  const t = g(), r = R("useSendMpqDeliveryDetails"), n = F(!1), i = F(!1), o = F();
  return {
    error: o,
    state: n,
    isLoading: i,
    execute: fe(async (a) => {
      n.value = !1, o.value = void 0;
      try {
        await t.deliverSynchronyMpqApplicationUrl(f(e), a), n.value = !0;
      } catch (c) {
        r.error(`Failed sending mpq link to ${a}`, c), B(c), o.value = c;
      }
    }, i)
  };
}, qc = () => {
  const e = g();
  return {
    verify: async (n) => await e.getRecaptchaVerificationResult(n),
    start: async () => e.startRecaptchaVerification()
  };
}, Ss = () => {
  const e = O();
  return h(() => e.extensions.find((r) => r.featureId === "recaptcha")?.properties);
}, Gc = () => {
  const e = Ss(), t = () => !!window.grecaptcha && !!window.grecaptcha.enterprise && !!window.grecaptcha.enterprise.ready;
  return {
    initializeRecaptcha: (c) => {
      const l = document.createElement("script");
      l.setAttribute(
        "src",
        c ?? `https://www.google.com/recaptcha/enterprise.js?render=${e.value?.siteKey}`
      ), document.head.appendChild(l);
    },
    executeRecaptcha: async () => {
      t() && window.grecaptcha.enterprise.ready(async () => {
        await window.grecaptcha.enterprise.execute();
      });
    },
    renderRecaptcha: (c, l) => {
      e.value && window.grecaptcha.enterprise.ready(async () => {
        window.grecaptcha.enterprise.render(c, {
          sitekey: e.value?.siteKey,
          callback: l
        });
      });
    },
    isRecaptchaInitialized: t,
    waitForRecaptchaInitialization: () => new Promise((c) => {
      const l = () => {
        t() ? c() : setTimeout(l, 250);
      };
      l();
    }),
    unloadRecaptcha: (c) => {
      const l = document.head.getElementsByTagName("script");
      for (const d of l)
        d.src.startsWith(
          c ?? `https://www.google.com/recaptcha/enterprise.js?render=${e.value?.siteKey}`
        ) && document.head.removeChild(d);
    },
    resetRecaptcha: async () => {
      t() && window.grecaptcha.enterprise.ready(async () => {
        window.grecaptcha.enterprise.reset();
      });
    }
  };
}, _t = (e) => e.waterfallStatus === "completed" || e.waterfallStatus === "expired", $c = (e) => {
  const t = g(), r = O();
  Oe(async () => {
    const i = r.waterfallResume;
    if (i == null)
      return !0;
    if (_t(i))
      return await e(i), !0;
    const o = await t.getWaterfallResumeStatus(i.waterfallSessionId);
    return r.updateResume(o), await x(), i.waterfallStatus !== o.waterfallStatus && await e(o), _t(o);
  }, 5e3);
}, Vc = () => {
  const e = _(), t = O(), r = g(), n = We(), i = ee();
  return async (o, s) => {
    const c = await X().instrument("end flow", async () => {
      let d;
      try {
        d = await r.finishFlow(o, s);
      } catch (p) {
        B(p), d = {};
      }
      return t.flowType === "apply" && i({
        type: "end",
        flow: "application",
        outcome: o
      }), d;
    })(), l = c?.transition;
    if (o === "timeout") {
      const d = n.afterEach(() => {
        e.resetAll(), d();
      });
      return c;
    } else
      e.resetAll();
    if (l?.type === "redirect") {
      const d = Rs(l.destination, r.baseUrl);
      document.body.appendChild(d), d.submit();
    }
    return c;
  };
};
function Rs(e, t) {
  const r = document.createElement("form"), n = document.createElement("input");
  return r.action = `${t}/api/v1/flow/finish/redirect`, r.method = "POST", r.style.display = "none", n.type = "text", n.name = "destination", n.value = e, r.appendChild(n), r;
}
const Wc = () => {
  const e = O(), t = g(), r = ee();
  return async (n) => {
    await t.finishFlow("completed", {
      providerKey: n.providerKey
    }), r({
      type: "checkout",
      applicationId: n.versatileApplicationId,
      applicationWasResumed: e.providerResume?.requestedProviderKey === n.providerKey,
      token: n.checkoutToken
    });
  };
}, jc = () => {
  const e = O();
  return h(() => (e.storefrontSdk?.enabled ?? !1) && ze());
}, bs = (e = {}) => {
  const t = R("useGenerateTrustEvSessionId"), r = pn(
    e.url ?? "https://cdn-us.trustev.com/trustev.min.js",
    () => {
      t.debug("trustev library loaded");
    },
    {
      manual: !0
    }
  );
  return async (n) => {
    await r.load(!0);
    const i = window.TrustevV2;
    if (!i)
      throw new Error("trustev library not found");
    return t.info(`generating a trustev session for ${n}`), new Promise((o, s) => {
      const a = window.setTimeout(
        () => s(
          new Error(
            `timed out waiting for trustev session generation for ${n}`
          )
        ),
        e.timeout ?? 5e3
      );
      i.Init(n, (c) => {
        window.clearTimeout(a), t.info(`successfully generated a trustev session for ${n}`), o(c);
      });
    });
  };
}, Hc = (e) => {
  const t = Ar(), r = f(e), n = Ji(r), i = O(), o = R("useSendCode");
  return async (s, a) => {
    try {
      const c = await t.sendVerificationCode(
        s,
        a
      );
      return n.value && i.flowType === "apply" && (s.email && (n.value.email = s.email), s.mobilePhone && (n.value.mobilePhone = s.mobilePhone)), c;
    } catch (c) {
      return o.error(
        `Failed to send verification code for provider ${a}: `,
        c
      ), {
        status: Ht.ERROR
      };
    }
  };
}, zc = () => {
  const e = Ar(), t = R("useVerifyCode");
  return async (r, n) => {
    try {
      return await e.verifyVerificationCode(
        r,
        n
      );
    } catch (i) {
      return t.error(`Error verifying code for provider ${n}: `, i), {
        status: zt.ERROR
      };
    }
  };
};
function Yc(e, t) {
  const r = F(!1), n = F(!1), i = F(!1);
  return {
    attempted: r,
    unauthorized: n,
    sendSuccess: i,
    verify: async () => {
      i.value = !1, r.value = !0;
      const a = await t();
      return n.value = a.status != zt.SUCCESS, a;
    },
    send: async () => {
      r.value = !1, n.value = !1, i.value = !1;
      const a = await e();
      return i.value = a.status === Ht.SUCCESS, a;
    }
  };
}
const Qc = () => {
  const e = O();
  return () => e.extensions.find(
    (r) => r.flowPosition === "pre_application"
  ) != null;
}, Es = () => {
  const e = w(), t = R("useIovationBlackbox");
  return async () => (t.info("loading iovation blackbox"), new Promise((r) => {
    window.io_global_object_name = "IGLOO", window.IGLOO = {
      enable_flash: !1,
      bb_callback: function(n, i) {
        i && (t.debug(
          "Updating device fingerprint with Iovation blackbox",
          n
        ), e.setApplicationValue("device.fingerprint", n), r(void 0));
      },
      loader: {
        fp_dyn: !1,
        version: "general5"
      }
    }, import("./iovation-loader-OR6Yh91O.js").then(() => t.debug("Iovation snare loaded")).catch((n) => t.error("Unable to load Iovation snare", n));
  }).then(() => t.info("Iovation device fingerprinting complete")).catch((r) => t.error("Iovation device fingerprinting failed", r)));
}, Jc = () => {
  const e = v(), t = Es(), r = bs(), n = R("useFraudDetection");
  return async () => {
    let i = !1;
    for (const o of e.cascade)
      if (o.properties?.iovationEnabled && (i = !0), o.properties?.trustEvPublicKey) {
        const s = await r(
          o.properties.trustEvPublicKey
        );
        e.setTrustSessionId(o.providerKey, s);
      }
    i && (t(), n.info("loaded iovation blackbox"));
  };
};
export {
  Gi as AccountService,
  Mn as AcimaModule,
  On as AdsModule,
  Tn as AffModule,
  xr as AppOptionsKey,
  oi as ApplicantOfferModel,
  na as ApplicationOfferModel,
  le as ApplicationService,
  _n as AquaModule,
  Dn as BreadModule,
  Me as Buffers,
  js as CompositePredicate,
  qe as Content,
  Ge as ContentFormat,
  J as ContentType,
  ht as Contents,
  ac as Countries,
  Ze as DEFAULT_GENERAL_ROUTE_MAPPINGS,
  Pc as DefaultI18nOptions,
  mt as DefaultModule,
  ge as Device,
  li as DeviceCapability,
  Fn as DividendModule,
  ke as DynamicProviderKey,
  V as FlowService,
  Nn as FortivaModule,
  xn as FoundationModule,
  Ln as GafModule,
  Tr as GeneralRouteMappingsKey,
  Un as GenesisModule,
  K as GoogleTagManager,
  Kn as GreenskyModule,
  Bn as HfdModule,
  si as IncomeCollectionType,
  Fe as InjectionKeys,
  kn as KafeneModule,
  qn as KoalafiModule,
  Gn as LendingClubModule,
  $n as LendingPointModule,
  Uo as LogicalRouter,
  ii as Modules,
  Vn as MomntModule,
  Re as PaymentPlanService,
  Wn as PowerPayModule,
  jn as ProceedModule,
  Hn as ProgressiveModule,
  zi as ProviderSwitchResult,
  Y as RoundingMode,
  _r as RouteConditionEvaluatorKey,
  $o as RouterPlugin,
  zn as ServiceFinanceModule,
  To as Services,
  Qn as SnapModule,
  Yn as SonravaModule,
  sc as States,
  Io as StipulationService,
  ye as SubmitApplicationContext,
  ve as SubmitApplicationResult,
  Jn as SunlightModule,
  Zn as SynchronyModule,
  Xn as TdBankModule,
  Mo as TermsService,
  Oo as TestCaseService,
  ei as TgucModule,
  yt as URI,
  ti as UpgradeModule,
  Co as ValidationService,
  pi as VerificationDeliveryMethod,
  vr as VerificationService,
  ri as WatercressModule,
  ni as WellsFargoModule,
  Xs as and,
  ar as applicantByType,
  Hs as approvedResponse,
  Gs as arrayRemove,
  fa as atBottomOfDocument,
  ma as atBottomOfElement,
  Pi as buildBufferSource,
  dr as buildEncryptionKey,
  Zs as byJointApplicant,
  Js as byPrimaryApplicant,
  Ee as calculateActualDownPaymentAmount,
  pa as calculateNextPayDate,
  ta as computedFilter,
  ea as computedQuery,
  ec as createRelativeRedirect,
  el as daysBetween,
  $s as debounce,
  Vs as debounceAsync,
  Ai as decrypt,
  Wo as defineProviderRoutes,
  ui as disclosureToContent,
  vt as downloadBlob,
  vi as downloadContent,
  yi as downloadUrl,
  Ti as enableDevTools,
  wi as encrypt,
  ha as enumToPath,
  se as executeLater,
  ra as extractOptionalProviderKey,
  N as extractProviderKey,
  Sa as fillPath,
  Be as filter,
  wn as first,
  pc as formatAccountNumber,
  ca as formatCurrency,
  ur as formatDate,
  da as formatLocalDate,
  ua as formatLocaleDate,
  wa as formatPercent,
  dc as formatPhone,
  fc as formatSsn,
  mc as formatSsnLast4,
  la as fullDaysBetween,
  yr as generateUUID,
  fi as getAppBaseUrl,
  di as getDevice,
  hi as getFilenameFromUrl,
  pt as getProperty,
  U as getProviderModule,
  tl as localDate,
  Ra as maskOptionalValue,
  _i as maskValue,
  Rt as not,
  ia as optionalDisclosureToContent,
  aa as parseCurrency,
  En as pendingResponse,
  ft as prequalifiedResponse,
  va as preventBack,
  Ke as query,
  Aa as rejectWithMessage,
  qs as replaceApplyStageInUrlPath,
  Qi as reportCustomError,
  B as reportSessionError,
  sr as responseByApplicantType,
  zs as responseByProvider,
  Cn as responseByProviderKey,
  Ys as responseForApplicant,
  Qs as responseForJointApplicant,
  tc as runApp,
  ya as scrollToInvalidElement,
  sa as sendUrlThroughProxy,
  Pe as setQueryStringParams,
  Ws as sleep,
  An as sortBy,
  uc as toNumberOrdinal,
  _o as toRouteLocation,
  Ie as toUri,
  ba as todo,
  oa as tryToUri,
  Qa as uriToEvent,
  Ja as useAcceptOffer,
  oc as useAccountLookup,
  hc as useAnswerQuiz,
  Oa as useAppFieldGroupRules,
  Ta as useAppFieldResponse,
  rl as useAppI18n,
  Lr as useAppOptions,
  _ as useAppStore,
  Ji as useApplicant,
  Ba as useApplicationDocuments,
  vc as useApplicationLocales,
  Qe as useApplicationService,
  w as useApplicationStore,
  fe as useAsync,
  Ic as useCalculateProviderOffers,
  rc as useCheckUserExists,
  ka as useConfirmPaymentPlan,
  Zi as useCurrentApplyResponse,
  Ma as useCurrentProviderConfig,
  te as useCurrentProviderKey,
  Ca as useCurrentStaticProviderKey,
  cc as useDeliverApplicationDocuments,
  Xi as useDownPaymentAmount,
  Xa as useErrorRouter,
  Ve as useErrorStore,
  Za as useEvaluateRouteCondition,
  ps as useFetchPaymentPlans,
  bc as useFetchZipCodeMetadata,
  j as useFieldStore,
  Vc as useFinishFlow,
  Wc as useFinishWithCheckout,
  Fa as useFlowService,
  Jc as useFraudDetection,
  Nr as useGeneralRouteMappings,
  bs as useGenerateTrustEvSessionId,
  qa as useGetApplyTermsUrl,
  $i as useGetInvalidFields,
  Ia as useHasProvidersAfterCurrent,
  Ro as useHostedFlowConfig,
  bo as useHostedFlowPersistence,
  Ga as useInstallationAddress,
  _a as useIsAppFieldPresent,
  Cc as useIsExploreOffersViewAvailable,
  Qc as useIsPreApplicationWorkflowPresent,
  jc as useIsStorefrontSdkControlled,
  $a as useIsTopoff,
  wc as useLaunchMobileApply,
  W as useLocaleStore,
  R as useLogger,
  nc as useLoginProviderUser,
  Pa as useMemoize,
  Rc as useMerchantLegalName,
  Sc as useMerchantName,
  Ye as useMerchantStore,
  Bc as useMpqDeliveryDetails,
  ga as useNavigationStore,
  Va as useNextLenderInCascade,
  Wa as useOfferLookup,
  ja as usePatchApplication,
  Yi as usePaymentPlanService,
  Oe as usePolling,
  Ha as usePreauthResponse,
  Dc as usePrintReceipt,
  Fc as useProveConfig,
  Nc as useProveResendSms,
  xc as useProveSendSms,
  Lc as useProveStartApplication,
  Te as useProveStore,
  Uc as useProveWaitForSms,
  Kc as useProveWaitForVerification,
  Pr as useProviderConfig,
  gc as useProviderI18n,
  Da as useProviderInvalidFields,
  Hi as useProviderModule,
  Ec as useProviderOffers,
  v as useProviderStore,
  za as usePublishApplicationBypassEvent,
  Ya as usePublishCascadeConsent,
  ee as usePublishEvent,
  de as usePurchaseAmount,
  Ac as useQrCodeLaunch,
  yc as useQuiz,
  Gc as useRecaptchaApi,
  Ss as useRecaptchaConfig,
  qc as useRecaptchaVerification,
  Ka as useRefreshProviderStipulationStatus,
  gr as useRequireCurrentProviderKey,
  Mc as useRequireSelectedPlan,
  Oc as useReviewOffer,
  Vo as useRouteConditionEvaluator,
  Tc as useSelectOffer,
  ys as useSelectedPlan,
  Hc as useSendCode,
  ic as useSendLoginPasscode,
  kc as useSendMpqDeliveryDetails,
  O as useSessionStore,
  wr as useStartProvider,
  Na as useStipulationService,
  Eo as useSubmitApplication,
  Je as useSwitchProvider,
  xa as useTermsService,
  La as useTestCaseService,
  Ua as useValidationService,
  Yc as useVerification,
  Ar as useVerificationService,
  zc as useVerifyCode,
  lc as useWaitForApplicationDocumentsVerification,
  $c as useWaitForWaterfallResume,
  Fi as validateAmex,
  xi as validateDiscover,
  Ni as validateMastercard,
  Ea as validatePAN,
  Di as validateVisa,
  fr as windowHasOpener,
  mr as windowHasParent,
  ze as windowOpenedExternally
};
//# sourceMappingURL=index.es.js.map
